/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { AzureStorageSettingsEditDto, CacheDtoListResultDto, CarrierFinderProxyDto, CarrierFinderProxyOutputDto, CommissionEstimateDisclaimerEditDto, EmailDefaultsDto, EmailSettingsEditDto, EmailTemplateFromAddressSettingsEditDto, EmailTemplateSettingsEditDto, EmailUnsubscribeSettingsEditDto, GeneralSettingsEditDto, IStringEntityDto, ITenantSettingsEditDto, IntegrationSettingsEditDto, LdapSettingsEditDto, OrderManagementSettingsEditDto, PasswordComplexitySetting, QuoteManagementSettingsEditDto, SecuritySettingsEditDto, TenantUserManagementSettingsEditDto, TokenManagementSettingsEditDto } from './admin-proxies';
import { BackgroundJobCancellationRequestDto, BackgroundJobExecutionStatus, BackgroundJobOutputDto, IBackgroundJobExecutionDto, IInt64IdNameDto } from './commission-proxies';
import { ActivityEditDto, AdminEmailCannedResponseListDto, AttachmentListDto, AttachmentType, AttachmentTypeDeleteUpdateInput, CampaignType, CommunicationTypeEditDto, CommunicationTypeListDto, ContactAccountType, ContactCommunicationTypeDto, ContactDropdownDto, ContactGroupDto, ContactGroupEditDto, ContactGroupListDto, ContactListDtoPagedResultDto, ContactStatus, ContactViewOutput, ContactViewType, CreateAttachmentInput, CreateOrUpdateActivityUserInput, CreateOrUpdateCommunicationTypeInput, CreateOrUpdateContactGroupInput, CreateOrUpdateContactInput, CreateOrUpdateDocumentStorageInput, CreateOrUpdateEmailCannedResponseInput, CreateOrUpdateProductAttributeInput, CreateOrUpdateProductAttributeTypeInput, CreateOrUpdateProductCategoryInput, CreateOrUpdateProductInput, CreateOrUpdateProductMilestoneInput, DocumentStorageEditDto, EmailCannedResponseAdminEditDto, EmailCannedResponseDropdownDto, EmailOrderStatusInputDto, GetActivitiesOutput, GetAllActivitiesOutput, GetContactForEditOutput, GetDocumentNameListDto, GetMyActivitiesOutput, GetNotificationSettingsOutput, GetNotificationsOutput, GetOrdersWithoutFollowUpOutput, GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto, GetProductAttributeTypesForEditOutput, GetProductForEditOutput, GetProductMilestoneListDtoPagedResultDto, GetProductMilestoneSortedByIsAssignedOutputPagedResultDto, GetQuotesOrdersTicketsCountOutput, GetQuotesWithoutFollowUpOutput, GetTicketsWithoutFollowUpOutput, GetUserListForActivityOutput, IAdvisorEntitlementDto, IContactEditDto, IContactListDto, ICreateOrUpdateActivityInput, IFileDto, IGuidEntityDto, IPartnerEditDto, IPartnerSupportEditDto, IPartnersDto, IProductCategoryListDto, IProductListDto, ISalesCampaignDto, IUserListDto, IUserListRoleDto, NewProviderListNotificationInput, PartnerAcquisitionListDto, PartnerStatus, PartnerSupportType, ProductAttributeListDto, ProductAttributeTypeListDto, ProductCategoryAdminEditDto, ProductCategoryAdminListDto, SalesCampaignCreateEditInput, SalesCampaignDtoPagedResultModel, UpdateNotificationSettingsInput, UserNotification, UserNotificationState } from './common-proxies';
import { IUploadFileInput } from './customer-proxies';
import { CreateOrUpdatePartnerDevelopmentInput, CreateOrUpdatePartnerDocumentInput, CreateOrUpdatePartnerInput, CreateOrUpdatePartnerSalesSupportInput, CreateOrUpdatePartnerSourceInput, CreateOrUpdatePartnerSubAgencyInput, CreateOrUpdatePartnerSupportInput, CreatePartnerFromOpportunityInput, DropdownDto, GetPartnerActivityMilestoneListDto, GetPartnerDevelopmentListDto, GetPartnerDevelopmentStatusNameDto, GetPartnerForEditOutput, GetPartnerNameDto, GetPartnerQuotesByProviderListDto, GetPartnerSalesByProviderListDto, GetPartnerSourceListDtoPagedResultDto, GetPartnerSupportUsersDto, GetSimpleAgentListDto, GetUserListOutput, GetUsersFilteredByRoleOutputPagedResultDto, MarketingPartnerList, PartnerAddressListDto, PartnerContractTypeListDto, PartnerCustomerLocListDto, PartnerDevelopmentEditDto, PartnerDocumentDto, PartnerDropdownDto, PartnerListDtoPagedResultDto, PartnerPrincipleInformationDto, PartnerSalesSupportListDto, PartnerSubAgencyListDto, PartnerUserReport, PartnersAndUsersListDto, SalesAgentPartnerListForQuote, SupportContactDto, UpdatePartnerDevelopmentStatusInput } from './partner-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { DocumentType, IDocumentListDto, IEmailDetailInput } from './ticket-proxies';
import { ChangeUserLanguageDto, CreateOrUpdateUserInput, GetUserForEditOutput, GetUserInfoOutput, GetUserPermissionsForEditOutput, IUserLoginInfoDto, Int64EntityDto, RollDetails, UpdateUserPermissionsInput, UserDetailOutput, UserDropdownDto, UserListDtoPagedResultDto } from './user-proxies';

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateActivity(body: CreateOrUpdateActivityInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Activity/CreateOrUpdateActivity';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateActivity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateActivity(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateActivityUser(body: CreateOrUpdateActivityUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Activity/CreateOrUpdateActivityUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateActivityUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateActivityUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateActivityUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activityId (optional)
     * @return Success
     */
    getUsersList(activityId: number | undefined): Observable<GetUserListForActivityOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetUsersList?';
        if (activityId === null) throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined) url_ += 'ActivityId=' + encodeURIComponent('' + activityId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<GetUserListForActivityOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUserListForActivityOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersList(response: HttpResponseBase): Observable<GetUserListForActivityOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetUserListForActivityOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUserListForActivityOutput[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteActivityUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Activity/DeleteActivityUser?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteActivityUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteActivityUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteActivityUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activityKey (optional)
     * @param activityType (optional)
     * @return Success
     */
    getActivities(activityKey: number | undefined, activityType: ActivityType | undefined): Observable<GetActivitiesOutput> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetActivities?';
        if (activityKey === null) throw new Error("The parameter 'activityKey' cannot be null.");
        else if (activityKey !== undefined) url_ += 'ActivityKey=' + encodeURIComponent('' + activityKey) + '&';
        if (activityType === null) throw new Error("The parameter 'activityType' cannot be null.");
        else if (activityType !== undefined) url_ += 'ActivityType=' + encodeURIComponent('' + activityType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActivities(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActivities(<any>response_);
                        } catch (e) {
                            return <Observable<GetActivitiesOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetActivitiesOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActivities(response: HttpResponseBase): Observable<GetActivitiesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetActivitiesOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetActivitiesOutput>(<any>null);
    }

    /**
     * @param activityId (optional)
     * @return Success
     */
    toggleActivityCompletion(activityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Activity/ToggleActivityCompletion?';
        if (activityId === null) throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined) url_ += 'activityId=' + encodeURIComponent('' + activityId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processToggleActivityCompletion(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processToggleActivityCompletion(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processToggleActivityCompletion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activityId (optional)
     * @return Success
     */
    toggleActivityPrivacy(activityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Activity/ToggleActivityPrivacy?';
        if (activityId === null) throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined) url_ += 'activityId=' + encodeURIComponent('' + activityId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processToggleActivityPrivacy(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processToggleActivityPrivacy(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processToggleActivityPrivacy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activityKey (optional)
     * @param activityType (optional)
     * @param supportUserId (optional)
     * @param isComplete (optional)
     * @return Success
     */
    getAllActivities(
        activityKey: number | undefined,
        activityType: ActivityType | undefined,
        supportUserId: number | undefined,
        isComplete: boolean | undefined
    ): Observable<GetAllActivitiesOutput> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetAllActivities?';
        if (activityKey === null) throw new Error("The parameter 'activityKey' cannot be null.");
        else if (activityKey !== undefined) url_ += 'ActivityKey=' + encodeURIComponent('' + activityKey) + '&';
        if (activityType === null) throw new Error("The parameter 'activityType' cannot be null.");
        else if (activityType !== undefined) url_ += 'ActivityType=' + encodeURIComponent('' + activityType) + '&';
        if (supportUserId === null) throw new Error("The parameter 'supportUserId' cannot be null.");
        else if (supportUserId !== undefined) url_ += 'SupportUserId=' + encodeURIComponent('' + supportUserId) + '&';
        if (isComplete === null) throw new Error("The parameter 'isComplete' cannot be null.");
        else if (isComplete !== undefined) url_ += 'IsComplete=' + encodeURIComponent('' + isComplete) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllActivities(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllActivities(<any>response_);
                        } catch (e) {
                            return <Observable<GetAllActivitiesOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetAllActivitiesOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllActivities(response: HttpResponseBase): Observable<GetAllActivitiesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetAllActivitiesOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetAllActivitiesOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteActivity(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Activity/DeleteActivity?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteActivity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteActivity(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isComplete (optional)
     * @param assignedUserId (optional)
     * @return Success
     */
    getMyActivities(isComplete: boolean | undefined, assignedUserId: number | undefined): Observable<GetMyActivitiesOutput> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetMyActivities?';
        if (isComplete === null) throw new Error("The parameter 'isComplete' cannot be null.");
        else if (isComplete !== undefined) url_ += 'IsComplete=' + encodeURIComponent('' + isComplete) + '&';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'AssignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMyActivities(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMyActivities(<any>response_);
                        } catch (e) {
                            return <Observable<GetMyActivitiesOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetMyActivitiesOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMyActivities(response: HttpResponseBase): Observable<GetMyActivitiesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetMyActivitiesOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetMyActivitiesOutput>(<any>null);
    }

    /**
     * @param assignedUserId (optional)
     * @return Success
     */
    getQuotesOrdersTicketsCount(assignedUserId: number | undefined): Observable<GetQuotesOrdersTicketsCountOutput> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetQuotesOrdersTicketsCount?';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'assignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotesOrdersTicketsCount(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotesOrdersTicketsCount(<any>response_);
                        } catch (e) {
                            return <Observable<GetQuotesOrdersTicketsCountOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetQuotesOrdersTicketsCountOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotesOrdersTicketsCount(response: HttpResponseBase): Observable<GetQuotesOrdersTicketsCountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetQuotesOrdersTicketsCountOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetQuotesOrdersTicketsCountOutput>(<any>null);
    }

    /**
     * @param activityKey (optional)
     * @param type (optional)
     * @return Success
     */
    getQuoteIdOrOrderId(activityKey: number | undefined, type: number | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetQuoteIdOrOrderId?';
        if (activityKey === null) throw new Error("The parameter 'activityKey' cannot be null.");
        else if (activityKey !== undefined) url_ += 'ActivityKey=' + encodeURIComponent('' + activityKey) + '&';
        if (type === null) throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteIdOrOrderId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteIdOrOrderId(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteIdOrOrderId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param assignedUserId (optional)
     * @return Success
     */
    getQuotesWithoutFollowUp(assignedUserId: number | undefined): Observable<GetQuotesWithoutFollowUpOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetQuotesWithoutFollowUp?';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'assignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotesWithoutFollowUp(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotesWithoutFollowUp(<any>response_);
                        } catch (e) {
                            return <Observable<GetQuotesWithoutFollowUpOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetQuotesWithoutFollowUpOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotesWithoutFollowUp(response: HttpResponseBase): Observable<GetQuotesWithoutFollowUpOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetQuotesWithoutFollowUpOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetQuotesWithoutFollowUpOutput[]>([]);
    }

    /**
     * @param assignedUserId (optional)
     * @return Success
     */
    getOrdersWithoutFollowUp(assignedUserId: number | undefined): Observable<GetOrdersWithoutFollowUpOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetOrdersWithoutFollowUp?';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'assignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrdersWithoutFollowUp(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrdersWithoutFollowUp(<any>response_);
                        } catch (e) {
                            return <Observable<GetOrdersWithoutFollowUpOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetOrdersWithoutFollowUpOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrdersWithoutFollowUp(response: HttpResponseBase): Observable<GetOrdersWithoutFollowUpOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetOrdersWithoutFollowUpOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetOrdersWithoutFollowUpOutput[]>([]);
    }

    /**
     * @param assignedUserId (optional)
     * @return Success
     */
    getTicketsWithoutFollowUp(assignedUserId: number | undefined): Observable<GetTicketsWithoutFollowUpOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Activity/GetTicketsWithoutFollowUp?';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'assignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketsWithoutFollowUp(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketsWithoutFollowUp(<any>response_);
                        } catch (e) {
                            return <Observable<GetTicketsWithoutFollowUpOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetTicketsWithoutFollowUpOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketsWithoutFollowUp(response: HttpResponseBase): Observable<GetTicketsWithoutFollowUpOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetTicketsWithoutFollowUpOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetTicketsWithoutFollowUpOutput[]>([]);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<CacheDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Caching/GetAllCaches';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllCaches(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllCaches(<any>response_);
                        } catch (e) {
                            return <Observable<CacheDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CacheDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<CacheDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CacheDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CacheDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    clearCache(body: StringEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Caching/ClearCache';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processClearCache(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processClearCache(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Caching/ClearAllCaches';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processClearAllCaches(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processClearAllCaches(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    createContactFromUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/CreateContactFromUser?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateContactFromUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateContactFromUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateContactFromUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateContact(body: CreateOrUpdateContactInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/CreateOrUpdateContact';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateContact(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateContact(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param name (optional)
     * @param contactStatus (optional)
     * @param contactSource (optional)
     * @param sourceAccount (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getContactList(
        name: string | undefined,
        contactStatus: string | undefined,
        contactSource: number | undefined,
        sourceAccount: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<ContactListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactList?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        if (contactStatus === null) throw new Error("The parameter 'contactStatus' cannot be null.");
        else if (contactStatus !== undefined) url_ += 'ContactStatus=' + encodeURIComponent('' + contactStatus) + '&';
        if (contactSource === null) throw new Error("The parameter 'contactSource' cannot be null.");
        else if (contactSource !== undefined) url_ += 'ContactSource=' + encodeURIComponent('' + contactSource) + '&';
        if (sourceAccount === null) throw new Error("The parameter 'sourceAccount' cannot be null.");
        else if (sourceAccount !== undefined) url_ += 'SourceAccount=' + encodeURIComponent('' + sourceAccount) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactList(<any>response_);
                        } catch (e) {
                            return <Observable<ContactListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactList(response: HttpResponseBase): Observable<ContactListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ContactListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteContact(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/DeleteContact?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteContact(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteContact(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getUserIdFromContact(input: number | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetUserIdFromContact?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserIdFromContact(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserIdFromContact(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserIdFromContact(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getContactForEdit(id: number | undefined): Observable<GetContactForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetContactForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetContactForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactForEdit(response: HttpResponseBase): Observable<GetContactForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetContactForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetContactForEditOutput>(<any>null);
    }

    /**
     * @param contactSource (optional)
     * @param sourceAccount (optional)
     * @return Success
     */
    getModalContactList(contactSource: number | undefined, sourceAccount: number | undefined): Observable<ContactListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetModalContactList?';
        if (contactSource === null) throw new Error("The parameter 'contactSource' cannot be null.");
        else if (contactSource !== undefined) url_ += 'ContactSource=' + encodeURIComponent('' + contactSource) + '&';
        if (sourceAccount === null) throw new Error("The parameter 'sourceAccount' cannot be null.");
        else if (sourceAccount !== undefined) url_ += 'SourceAccount=' + encodeURIComponent('' + sourceAccount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetModalContactList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetModalContactList(<any>response_);
                        } catch (e) {
                            return <Observable<ContactListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetModalContactList(response: HttpResponseBase): Observable<ContactListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactListDto[]>([]);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getCommunicationTypeList(filter: string | undefined): Observable<CommunicationTypeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetCommunicationTypeList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommunicationTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommunicationTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<CommunicationTypeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommunicationTypeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommunicationTypeList(response: HttpResponseBase): Observable<CommunicationTypeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(CommunicationTypeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommunicationTypeListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCommunicationTypeForEdit(id: number | undefined): Observable<CommunicationTypeEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetCommunicationTypeForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommunicationTypeForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommunicationTypeForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<CommunicationTypeEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CommunicationTypeEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommunicationTypeForEdit(response: HttpResponseBase): Observable<CommunicationTypeEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CommunicationTypeEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CommunicationTypeEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/DeleteType?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCommunicationType(body: CreateOrUpdateCommunicationTypeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/CreateOrUpdateCommunicationType';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateCommunicationType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateCommunicationType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateCommunicationType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param contactId (optional)
     * @return Success
     */
    getContactCommunicationTypeList(contactId: number | undefined): Observable<ContactCommunicationTypeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactCommunicationTypeList?';
        if (contactId === null) throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined) url_ += 'contactId=' + encodeURIComponent('' + contactId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactCommunicationTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactCommunicationTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<ContactCommunicationTypeDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactCommunicationTypeDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactCommunicationTypeList(response: HttpResponseBase): Observable<ContactCommunicationTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactCommunicationTypeDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactCommunicationTypeDto[]>([]);
    }

    /**
     * @param contactId (optional)
     * @param communicationTypeId (optional)
     * @return Success
     */
    addOrDeleteContactCommunication(contactId: number | undefined, communicationTypeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/AddOrDeleteContactCommunication?';
        if (contactId === null) throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined) url_ += 'contactId=' + encodeURIComponent('' + contactId) + '&';
        if (communicationTypeId === null) throw new Error("The parameter 'communicationTypeId' cannot be null.");
        else if (communicationTypeId !== undefined) url_ += 'communicationTypeId=' + encodeURIComponent('' + communicationTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processAddOrDeleteContactCommunication(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processAddOrDeleteContactCommunication(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processAddOrDeleteContactCommunication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param providerId (optional)
     * @return Success
     * @deprecated
     */
    getAllContacts(providerId: number | undefined): Observable<ContactDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetAllContacts?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllContacts(<any>response_);
                        } catch (e) {
                            return <Observable<ContactDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllContacts(response: HttpResponseBase): Observable<ContactDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactDropdownDto[]>([]);
    }

    /**
     * @param contactAccountType (optional)
     * @param contactAccountKey (optional)
     * @return Success
     */
    getNonChildContacts(contactAccountType: number | undefined, contactAccountKey: number | undefined): Observable<ContactDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetNonChildContacts?';
        if (contactAccountType === null) throw new Error("The parameter 'contactAccountType' cannot be null.");
        else if (contactAccountType !== undefined) url_ += 'contactAccountType=' + encodeURIComponent('' + contactAccountType) + '&';
        if (contactAccountKey === null) throw new Error("The parameter 'contactAccountKey' cannot be null.");
        else if (contactAccountKey !== undefined) url_ += 'contactAccountKey=' + encodeURIComponent('' + contactAccountKey) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetNonChildContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetNonChildContacts(<any>response_);
                        } catch (e) {
                            return <Observable<ContactDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetNonChildContacts(response: HttpResponseBase): Observable<ContactDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactDropdownDto[]>([]);
    }

    /**
     * @param contactViewType (optional)
     * @return Success
     */
    getContactViewGroups(contactViewType: number | undefined): Observable<ContactGroupDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactViewGroups?';
        if (contactViewType === null) throw new Error("The parameter 'contactViewType' cannot be null.");
        else if (contactViewType !== undefined) url_ += 'contactViewType=' + encodeURIComponent('' + contactViewType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactViewGroups(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactViewGroups(<any>response_);
                        } catch (e) {
                            return <Observable<ContactGroupDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactGroupDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactViewGroups(response: HttpResponseBase): Observable<ContactGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactGroupDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactGroupDto[]>([]);
    }

    /**
     * @param contactViewType (optional)
     * @param accountKey (optional)
     * @return Success
     */
    getContactViewContacts(contactViewType: number | undefined, accountKey: number | undefined): Observable<ContactViewOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactViewContacts?';
        if (contactViewType === null) throw new Error("The parameter 'contactViewType' cannot be null.");
        else if (contactViewType !== undefined) url_ += 'contactViewType=' + encodeURIComponent('' + contactViewType) + '&';
        if (accountKey === null) throw new Error("The parameter 'accountKey' cannot be null.");
        else if (accountKey !== undefined) url_ += 'accountKey=' + encodeURIComponent('' + accountKey) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactViewContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactViewContacts(<any>response_);
                        } catch (e) {
                            return <Observable<ContactViewOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactViewOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactViewContacts(response: HttpResponseBase): Observable<ContactViewOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactViewOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactViewOutput[]>([]);
    }

    /**
     * @param state (optional)
     * @param contactViewType (optional)
     * @param contactGroupId (optional)
     * @param accountKey (optional)
     * @return Success
     */
    getRegionalContactViewContacts(
        state: string | undefined,
        contactViewType: number | undefined,
        contactGroupId: number | undefined,
        accountKey: number | undefined
    ): Observable<ContactViewOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetRegionalContactViewContacts?';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'state=' + encodeURIComponent('' + state) + '&';
        if (contactViewType === null) throw new Error("The parameter 'contactViewType' cannot be null.");
        else if (contactViewType !== undefined) url_ += 'contactViewType=' + encodeURIComponent('' + contactViewType) + '&';
        if (contactGroupId === null) throw new Error("The parameter 'contactGroupId' cannot be null.");
        else if (contactGroupId !== undefined) url_ += 'contactGroupId=' + encodeURIComponent('' + contactGroupId) + '&';
        if (accountKey === null) throw new Error("The parameter 'accountKey' cannot be null.");
        else if (accountKey !== undefined) url_ += 'accountKey=' + encodeURIComponent('' + accountKey) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRegionalContactViewContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRegionalContactViewContacts(<any>response_);
                        } catch (e) {
                            return <Observable<ContactViewOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactViewOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRegionalContactViewContacts(response: HttpResponseBase): Observable<ContactViewOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactViewOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactViewOutput[]>([]);
    }

    /**
     * @param parentContactId (optional)
     * @return Success
     */
    getChildrenContacts(parentContactId: number | undefined): Observable<ContactViewOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetChildrenContacts?';
        if (parentContactId === null) throw new Error("The parameter 'parentContactId' cannot be null.");
        else if (parentContactId !== undefined) url_ += 'parentContactId=' + encodeURIComponent('' + parentContactId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetChildrenContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetChildrenContacts(<any>response_);
                        } catch (e) {
                            return <Observable<ContactViewOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactViewOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetChildrenContacts(response: HttpResponseBase): Observable<ContactViewOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactViewOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactViewOutput[]>([]);
    }

    /**
     * @param contactViewType (optional)
     * @return Success
     */
    getAllContactsReportToExcel(contactViewType: ContactViewType | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetAllContactsReportToExcel?';
        if (contactViewType === null) throw new Error("The parameter 'contactViewType' cannot be null.");
        else if (contactViewType !== undefined) url_ += 'contactViewType=' + encodeURIComponent('' + contactViewType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllContactsReportToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllContactsReportToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllContactsReportToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getContactGroupActionTypeNameList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactGroupActionTypeNameList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactGroupActionTypeNameList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactGroupActionTypeNameList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactGroupActionTypeNameList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return Success
     */
    getContactTypeNameList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactTypeNameList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactTypeNameList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactTypeNameList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactTypeNameList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getContactViewList(filter: string | undefined): Observable<ContactGroupListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactViewList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactViewList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactViewList(<any>response_);
                        } catch (e) {
                            return <Observable<ContactGroupListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactGroupListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactViewList(response: HttpResponseBase): Observable<ContactGroupListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ContactGroupListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactGroupListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getContactGroupForEdit(id: number | undefined): Observable<ContactGroupEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Contact/GetContactGroupForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactGroupForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactGroupForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<ContactGroupEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ContactGroupEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactGroupForEdit(response: HttpResponseBase): Observable<ContactGroupEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ContactGroupEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ContactGroupEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateContactGroup(body: CreateOrUpdateContactGroupInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Contact/CreateOrUpdateContactGroup';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateContactGroup(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateContactGroup(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateContactGroup(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletecontactGroup(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Contact/DeletecontactGroup?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletecontactGroup(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletecontactGroup(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletecontactGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DocumentStorageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    uploadDocumentStorageFile(
        contentType: string | undefined,
        contentDisposition: string | undefined,
        headers: { [key: string]: string[] } | undefined,
        length: number | undefined,
        name: string | undefined,
        fileName: string | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/DocumentStorage/UploadDocumentStorageFile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = new FormData();
        if (contentType === null || contentType === undefined) throw new Error("The parameter 'contentType' cannot be null.");
        else content_.append('ContentType', contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else content_.append('ContentDisposition', contentDisposition.toString());
        if (headers === null || headers === undefined) throw new Error("The parameter 'headers' cannot be null.");
        else content_.append('Headers', JSON.stringify(headers));
        if (length === null || length === undefined) throw new Error("The parameter 'length' cannot be null.");
        else content_.append('Length', length.toString());
        if (name === null || name === undefined) throw new Error("The parameter 'name' cannot be null.");
        else content_.append('Name', name.toString());
        if (fileName === null || fileName === undefined) throw new Error("The parameter 'fileName' cannot be null.");
        else content_.append('FileName', fileName.toString());

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUploadDocumentStorageFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUploadDocumentStorageFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUploadDocumentStorageFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createDocumentStorage(body: CreateOrUpdateDocumentStorageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/CreateDocumentStorageAsync';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateDocumentStorage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateDocumentStorage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateDocumentStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    download(body: DocumentStorageEditDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/DownloadAsync';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDownload(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDownload(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDownload(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    downloadToFile(body: DocumentStorageEditDto | undefined): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/DownloadToFileAsync';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDownloadToFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDownloadToFile(<any>response_);
                        } catch (e) {
                            return <Observable<string>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDownloadToFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param documentName (optional)
     * @param providerId (optional)
     * @param documentType (optional)
     * @param key (optional)
     * @return Success
     * @deprecated
     */
    deleteDocumentStorage(
        documentName: string | undefined,
        providerId: number | undefined,
        documentType: DocumentType | undefined,
        key: number | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/DeleteDocumentStorageAsync?';
        if (documentName === null) throw new Error("The parameter 'documentName' cannot be null.");
        else if (documentName !== undefined) url_ += 'DocumentName=' + encodeURIComponent('' + documentName) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (documentType === null) throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined) url_ += 'DocumentType=' + encodeURIComponent('' + documentType) + '&';
        if (key === null) throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined) url_ += 'Key=' + encodeURIComponent('' + key) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteDocumentStorage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteDocumentStorage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteDocumentStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param documentType (optional)
     * @param key (optional)
     * @param providerId (optional)
     * @return Success
     */
    getAttachmentDocuments(
        documentType: DocumentType | undefined,
        key: number | undefined,
        providerId: number | undefined
    ): Observable<AttachmentListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/GetAttachmentDocuments?';
        if (documentType === null) throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined) url_ += 'DocumentType=' + encodeURIComponent('' + documentType) + '&';
        if (key === null) throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined) url_ += 'Key=' + encodeURIComponent('' + key) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAttachmentDocuments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAttachmentDocuments(<any>response_);
                        } catch (e) {
                            return <Observable<AttachmentListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AttachmentListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAttachmentDocuments(response: HttpResponseBase): Observable<AttachmentListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AttachmentListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttachmentListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createAttachmentDocumentStorage(body: CreateAttachmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/CreateAttachmentDocumentStorageAsync';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateAttachmentDocumentStorage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateAttachmentDocumentStorage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateAttachmentDocumentStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fileSize (optional)
     * @param fileExtension (optional)
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createAttachmentFromDownloadedFile(
        fileSize: number | undefined,
        fileExtension: string | undefined,
        body: CreateAttachmentInput | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/CreateAttachmentFromDownloadedFileAsync?';
        if (fileSize === null) throw new Error("The parameter 'fileSize' cannot be null.");
        else if (fileSize !== undefined) url_ += 'fileSize=' + encodeURIComponent('' + fileSize) + '&';
        if (fileExtension === null) throw new Error("The parameter 'fileExtension' cannot be null.");
        else if (fileExtension !== undefined) url_ += 'fileExtension=' + encodeURIComponent('' + fileExtension) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateAttachmentFromDownloadedFile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateAttachmentFromDownloadedFile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateAttachmentFromDownloadedFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param attachmentId (optional)
     * @param documentName (optional)
     * @param providerId (optional)
     * @param documentType (optional)
     * @param key (optional)
     * @return Success
     */
    deleteAttachmentDocumentStorage(
        attachmentId: number | undefined,
        documentName: string | undefined,
        providerId: number | undefined,
        documentType: DocumentType | undefined,
        key: number | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/DeleteAttachmentDocumentStorageAsync?';
        if (attachmentId === null) throw new Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined) url_ += 'AttachmentId=' + encodeURIComponent('' + attachmentId) + '&';
        if (documentName === null) throw new Error("The parameter 'documentName' cannot be null.");
        else if (documentName !== undefined) url_ += 'DocumentName=' + encodeURIComponent('' + documentName) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (documentType === null) throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined) url_ += 'DocumentType=' + encodeURIComponent('' + documentType) + '&';
        if (key === null) throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined) url_ += 'Key=' + encodeURIComponent('' + key) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAttachmentDocumentStorage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAttachmentDocumentStorage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAttachmentDocumentStorage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAttachmentTypeList(): Observable<AttachmentType[]> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/GetAttachmentTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAttachmentTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAttachmentTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<AttachmentType[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AttachmentType[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAttachmentTypeList(response: HttpResponseBase): Observable<AttachmentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AttachmentType.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AttachmentType[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insertOrUpdateAttachmentType(body: AttachmentTypeDeleteUpdateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/InsertOrUpdateAttachmentType';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processInsertOrUpdateAttachmentType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processInsertOrUpdateAttachmentType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processInsertOrUpdateAttachmentType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param name (optional)
     * @return Success
     */
    deleteAttachmentType(id: number | undefined, name: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/DeleteAttachmentType?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAttachmentType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAttachmentType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAttachmentType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param typeId (optional)
     * @return Success
     */
    updateAttachmentTypeByAttachment(id: number | undefined, typeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/UpdateAttachmentTypeByAttachment?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        if (typeId === null) throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined) url_ += 'typeId=' + encodeURIComponent('' + typeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateAttachmentTypeByAttachment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateAttachmentTypeByAttachment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateAttachmentTypeByAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param documentType (optional)
     * @param key (optional)
     * @param providerId (optional)
     * @return Success
     */
    getDocumentNameList(
        documentType: DocumentType | undefined,
        key: number | undefined,
        providerId: number | undefined
    ): Observable<GetDocumentNameListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/DocumentStorage/GetDocumentNameList?';
        if (documentType === null) throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined) url_ += 'DocumentType=' + encodeURIComponent('' + documentType) + '&';
        if (key === null) throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined) url_ += 'Key=' + encodeURIComponent('' + key) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetDocumentNameList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetDocumentNameList(<any>response_);
                        } catch (e) {
                            return <Observable<GetDocumentNameListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetDocumentNameListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetDocumentNameList(response: HttpResponseBase): Observable<GetDocumentNameListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetDocumentNameListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetDocumentNameListDto[]>([]);
    }
}

@Injectable()
export class EmailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendEmailFromClient(body: EmailDetailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Email/SendEmailFromClient';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendEmailFromClient(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendEmailFromClient(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendEmailFromClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param emailTo (optional)
     * @param emailFrom (optional)
     * @param emailBody (optional)
     * @param emailSubject (optional)
     * @param surveyContent (optional)
     * @return Success
     */
    sendEmailOrderMilestone(
        emailTo: string | undefined,
        emailFrom: string | undefined,
        emailBody: string | undefined,
        emailSubject: string | undefined,
        surveyContent: string | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Email/SendEmailOrderMilestone?';
        if (emailTo === null) throw new Error("The parameter 'emailTo' cannot be null.");
        else if (emailTo !== undefined) url_ += 'emailTo=' + encodeURIComponent('' + emailTo) + '&';
        if (emailFrom === null) throw new Error("The parameter 'emailFrom' cannot be null.");
        else if (emailFrom !== undefined) url_ += 'emailFrom=' + encodeURIComponent('' + emailFrom) + '&';
        if (emailBody === null) throw new Error("The parameter 'emailBody' cannot be null.");
        else if (emailBody !== undefined) url_ += 'emailBody=' + encodeURIComponent('' + emailBody) + '&';
        if (emailSubject === null) throw new Error("The parameter 'emailSubject' cannot be null.");
        else if (emailSubject !== undefined) url_ += 'emailSubject=' + encodeURIComponent('' + emailSubject) + '&';
        if (surveyContent === null) throw new Error("The parameter 'surveyContent' cannot be null.");
        else if (surveyContent !== undefined) url_ += 'surveyContent=' + encodeURIComponent('' + surveyContent) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendEmailOrderMilestone(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendEmailOrderMilestone(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendEmailOrderMilestone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendEmailOrderStatus(body: EmailOrderStatusInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Email/SendEmailOrderStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendEmailOrderStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendEmailOrderStatus(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendEmailOrderStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getAdminEmailCannedResponses(filter: string | undefined): Observable<AdminEmailCannedResponseListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Email/GetAdminEmailCannedResponses?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdminEmailCannedResponses(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdminEmailCannedResponses(<any>response_);
                        } catch (e) {
                            return <Observable<AdminEmailCannedResponseListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdminEmailCannedResponseListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdminEmailCannedResponses(response: HttpResponseBase): Observable<AdminEmailCannedResponseListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdminEmailCannedResponseListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdminEmailCannedResponseListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getEmailCannedResponseForEdit(id: number | undefined): Observable<EmailCannedResponseAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Email/GetEmailCannedResponseForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmailCannedResponseForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmailCannedResponseForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<EmailCannedResponseAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EmailCannedResponseAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEmailCannedResponseForEdit(response: HttpResponseBase): Observable<EmailCannedResponseAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = EmailCannedResponseAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmailCannedResponseAdminEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteEmailCannedResponse(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Email/DeleteEmailCannedResponse?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteEmailCannedResponse(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteEmailCannedResponse(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteEmailCannedResponse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateEmailCannedResponse(body: CreateOrUpdateEmailCannedResponseInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Email/CreateOrUpdateEmailCannedResponse';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateEmailCannedResponse(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateEmailCannedResponse(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateEmailCannedResponse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEmailCannedResponses(): Observable<EmailCannedResponseDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Email/GetEmailCannedResponses';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmailCannedResponses(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmailCannedResponses(<any>response_);
                        } catch (e) {
                            return <Observable<EmailCannedResponseDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EmailCannedResponseDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEmailCannedResponses(response: HttpResponseBase): Observable<EmailCannedResponseDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmailCannedResponseDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmailCannedResponseDropdownDto[]>([]);
    }

    /**
     * @param automationTypeId (optional)
     * @return Success
     */
    getEmailCannedResponsesByAutomationType(automationTypeId: number | undefined): Observable<EmailCannedResponseDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Email/GetEmailCannedResponsesByAutomationType?';
        if (automationTypeId === null) throw new Error("The parameter 'automationTypeId' cannot be null.");
        else if (automationTypeId !== undefined) url_ += 'automationTypeId=' + encodeURIComponent('' + automationTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetEmailCannedResponsesByAutomationType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetEmailCannedResponsesByAutomationType(<any>response_);
                        } catch (e) {
                            return <Observable<EmailCannedResponseDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<EmailCannedResponseDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetEmailCannedResponsesByAutomationType(response: HttpResponseBase): Observable<EmailCannedResponseDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(EmailCannedResponseDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<EmailCannedResponseDropdownDto[]>([]);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param state (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUserNotifications(
        state: UserNotificationState | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Notification/GetUserNotifications?';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'State=' + encodeURIComponent('' + state) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserNotifications(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserNotifications(<any>response_);
                        } catch (e) {
                            return <Observable<GetNotificationsOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetNotificationsOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetNotificationsOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetNotificationsOutput>(<any>null);
    }

    /**
     * @param state (optional)
     * @param assignedUserId (optional)
     * @return Success
     */
    getUserNotificationsForActivity(
        state: UserNotificationState | undefined,
        assignedUserId: number | undefined
    ): Observable<UserNotification[]> {
        let url_ = this.baseUrl + '/api/services/app/Notification/GetUserNotificationsForActivity?';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'State=' + encodeURIComponent('' + state) + '&';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'AssignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserNotificationsForActivity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserNotificationsForActivity(<any>response_);
                        } catch (e) {
                            return <Observable<UserNotification[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserNotification[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserNotificationsForActivity(response: HttpResponseBase): Observable<UserNotification[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserNotification.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserNotification[]>([]);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/SetAllNotificationsAsRead';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSetAllNotificationsAsRead(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSetAllNotificationsAsRead(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    enqueueSetAllNotificationsAsReadJob(): Observable<BackgroundJobExecutionDto> {
        let url_ = this.baseUrl + '/api/services/app/Notification/EnqueueSetAllNotificationsAsReadJob';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processEnqueueSetAllNotificationsAsReadJob(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processEnqueueSetAllNotificationsAsReadJob(<any>response_);
                        } catch (e) {
                            return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<BackgroundJobExecutionDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processEnqueueSetAllNotificationsAsReadJob(response: HttpResponseBase): Observable<BackgroundJobExecutionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = BackgroundJobExecutionDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<BackgroundJobExecutionDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setNotificationAsRead(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/SetNotificationAsRead';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSetNotificationAsRead(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSetNotificationAsRead(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Notification/GetNotificationSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetNotificationSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetNotificationSettings(<any>response_);
                        } catch (e) {
                            return <Observable<GetNotificationSettingsOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetNotificationSettingsOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetNotificationSettingsOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/UpdateNotificationSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateNotificationSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateNotificationSettings(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendNewQuoteProviderListNotification(body: NewProviderListNotificationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/SendNewQuoteProviderListNotification';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendNewQuoteProviderListNotification(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendNewQuoteProviderListNotification(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendNewQuoteProviderListNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PartnerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getPartnersCount(): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnersCount';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnersCount(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnersCount(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnersCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    isPartnerActive(partnerId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Partner/IsPartnerActive?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processIsPartnerActive(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processIsPartnerActive(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processIsPartnerActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param address (optional)
     * @param activeStatus (optional)
     * @param status (optional)
     * @param id (optional)
     * @param approvedStatus (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     * @deprecated
     */
    getPartners(
        filter: string | undefined,
        address: string | undefined,
        activeStatus: number | undefined,
        status: string | undefined,
        id: number | undefined,
        approvedStatus: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<PartnerListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartners?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (address === null) throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined) url_ += 'Address=' + encodeURIComponent('' + address) + '&';
        if (activeStatus === null) throw new Error("The parameter 'activeStatus' cannot be null.");
        else if (activeStatus !== undefined) url_ += 'ActiveStatus=' + encodeURIComponent('' + activeStatus) + '&';
        if (status === null) throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (approvedStatus === null) throw new Error("The parameter 'approvedStatus' cannot be null.");
        else if (approvedStatus !== undefined) url_ += 'ApprovedStatus=' + encodeURIComponent('' + approvedStatus) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartners(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartners(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartners(response: HttpResponseBase): Observable<PartnerListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerListDtoPagedResultDto>(<any>null);
    }

    /**
     * @return Success
     * @deprecated
     */
    getPartnersForDropdown(): Observable<PartnerDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnersForDropdown';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnersForDropdown(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnersForDropdown(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnersForDropdown(response: HttpResponseBase): Observable<PartnerDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerDropdownDto[]>([]);
    }

    /**
     * @return Success
     */
    getPartnerList(): Observable<PartnersDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnersDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnersDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerList(response: HttpResponseBase): Observable<PartnersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnersDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnersDto[]>([]);
    }

    /**
     * @param supportId (optional)
     * @return Success
     */
    getPartnerListBySupportUser(supportId: number | undefined): Observable<PartnersDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerListBySupportUser?';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'supportId=' + encodeURIComponent('' + supportId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerListBySupportUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerListBySupportUser(<any>response_);
                        } catch (e) {
                            return <Observable<PartnersDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnersDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerListBySupportUser(response: HttpResponseBase): Observable<PartnersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnersDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnersDto[]>([]);
    }

    /**
     * @return Success
     */
    getPartnerListForContactView(): Observable<PartnersDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerListForContactView';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerListForContactView(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerListForContactView(<any>response_);
                        } catch (e) {
                            return <Observable<PartnersDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnersDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerListForContactView(response: HttpResponseBase): Observable<PartnersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnersDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnersDto[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getPartnerName(partnerId: number | undefined): Observable<GetPartnerNameDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerName?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerName(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerName(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerNameDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerNameDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerName(response: HttpResponseBase): Observable<GetPartnerNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetPartnerNameDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerNameDto>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getPartnerPrincipleContactInformation(partnerId: number | undefined): Observable<PartnerPrincipleInformationDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerPrincipleContactInformation?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerPrincipleContactInformation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerPrincipleContactInformation(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerPrincipleInformationDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerPrincipleInformationDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerPrincipleContactInformation(response: HttpResponseBase): Observable<PartnerPrincipleInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerPrincipleInformationDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerPrincipleInformationDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getPartnersAndUsersList(input: string | undefined): Observable<PartnersAndUsersListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnersAndUsersList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnersAndUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnersAndUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnersAndUsersListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnersAndUsersListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnersAndUsersList(response: HttpResponseBase): Observable<PartnersAndUsersListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnersAndUsersListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnersAndUsersListDto[]>([]);
    }

    /**
     * @return Success
     */
    getMarketingPartnerList(): Observable<MarketingPartnerList[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetMarketingPartnerList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMarketingPartnerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMarketingPartnerList(<any>response_);
                        } catch (e) {
                            return <Observable<MarketingPartnerList[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<MarketingPartnerList[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMarketingPartnerList(response: HttpResponseBase): Observable<MarketingPartnerList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MarketingPartnerList.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MarketingPartnerList[]>([]);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getPartnerFilterList(input: string | undefined): Observable<PartnersDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerFilterList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerFilterList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerFilterList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnersDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnersDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerFilterList(response: HttpResponseBase): Observable<PartnersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnersDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnersDto[]>([]);
    }

    /**
     * @return Success
     */
    getPartnerToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerToExcel';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerForEdit(id: number | undefined): Observable<GetPartnerForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerForEdit(response: HttpResponseBase): Observable<GetPartnerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetPartnerForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getPartnerStatusList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerStatusList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerStatusList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return Success
     */
    getPartnerSourceTypeList(): Observable<{ [key: string]: string }> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSourceTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSourceTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSourceTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<{ [key: string]: string }>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<{ [key: string]: string }>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSourceTypeList(response: HttpResponseBase): Observable<{ [key: string]: string }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (resultData200) {
                        result200 = {} as any;
                        for (let key in resultData200) {
                            if (resultData200.hasOwnProperty(key)) result200[key] = resultData200[key];
                        }
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<{ [key: string]: string }>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerAssignedUsersList(id: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerAssignedUsersList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerAssignedUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerAssignedUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerAssignedUsersList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUsersList(id: number | undefined): Observable<GetUserListOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetUsersList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<GetUserListOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUserListOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersList(response: HttpResponseBase): Observable<GetUserListOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetUserListOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUserListOutput[]>([]);
    }

    /**
     * @param partnerIds (optional)
     * @return Success
     */
    getPartnerUsers(partnerIds: number[] | undefined): Observable<GetUserListOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerUsers?';
        if (partnerIds === null) throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds &&
                partnerIds.forEach((item) => {
                    url_ += 'partnerIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerUsers(<any>response_);
                        } catch (e) {
                            return <Observable<GetUserListOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUserListOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerUsers(response: HttpResponseBase): Observable<GetUserListOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetUserListOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUserListOutput[]>([]);
    }

    /**
     * @return Success
     */
    getContractTypeList(): Observable<PartnerContractTypeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetContractTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContractTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContractTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerContractTypeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerContractTypeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContractTypeList(response: HttpResponseBase): Observable<PartnerContractTypeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerContractTypeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerContractTypeListDto[]>([]);
    }

    /**
     * @return Success
     */
    getAddressList(): Observable<PartnerAddressListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetAddressList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAddressList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAddressList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerAddressListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerAddressListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAddressList(response: HttpResponseBase): Observable<PartnerAddressListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerAddressListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerAddressListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartner(body: CreateOrUpdatePartnerInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdatePartner';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartner(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartner(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePartner(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeletePartner?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartner(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    canSeeCommmissionMatrix(partnerId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CanSeeCommmissionMatrix?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCanSeeCommmissionMatrix(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCanSeeCommmissionMatrix(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCanSeeCommmissionMatrix(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerSourceList(id: number | undefined): Observable<GetPartnerSourceListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSourceList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSourceList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSourceList(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerSourceListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerSourceListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSourceList(response: HttpResponseBase): Observable<GetPartnerSourceListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetPartnerSourceListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerSourceListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartnerSource(body: CreateOrUpdatePartnerSourceInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdatePartnerSource';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerSource(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerSource(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePartnerSource(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeletePartnerSource?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartnerSource(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartnerSource(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartnerSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPartnerActivityMilestoneList(): Observable<GetPartnerActivityMilestoneListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerActivityMilestoneList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerActivityMilestoneList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerActivityMilestoneList(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerActivityMilestoneListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerActivityMilestoneListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerActivityMilestoneList(response: HttpResponseBase): Observable<GetPartnerActivityMilestoneListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetPartnerActivityMilestoneListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerActivityMilestoneListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerManagerList(id: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerManagerList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerManagerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerManagerList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerManagerList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getStrategicPartnerManagerList(id: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetStrategicPartnerManagerList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStrategicPartnerManagerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStrategicPartnerManagerList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStrategicPartnerManagerList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param type (optional)
     * @return Success
     * @deprecated
     */
    getUsersFilteredByPM(partnerId: number, type: PartnerSupportType | undefined): Observable<GetUsersFilteredByRoleOutputPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetUsersFilteredByPM?';
        if (partnerId === undefined || partnerId === null) throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (type === null) throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersFilteredByPM(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersFilteredByPM(<any>response_);
                        } catch (e) {
                            return <Observable<GetUsersFilteredByRoleOutputPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUsersFilteredByRoleOutputPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersFilteredByPM(response: HttpResponseBase): Observable<GetUsersFilteredByRoleOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetUsersFilteredByRoleOutputPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUsersFilteredByRoleOutputPagedResultDto>(<any>null);
    }

    /**
     * @param type (optional)
     * @return Success
     * @deprecated
     */
    getUsersFilteredBySPM(partnerId: number, type: PartnerSupportType | undefined): Observable<GetUsersFilteredByRoleOutputPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetUsersFilteredBySPM?';
        if (partnerId === undefined || partnerId === null) throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (type === null) throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersFilteredBySPM(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersFilteredBySPM(<any>response_);
                        } catch (e) {
                            return <Observable<GetUsersFilteredByRoleOutputPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUsersFilteredByRoleOutputPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersFilteredBySPM(response: HttpResponseBase): Observable<GetUsersFilteredByRoleOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetUsersFilteredByRoleOutputPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUsersFilteredByRoleOutputPagedResultDto>(<any>null);
    }

    /**
     * @param type (optional)
     * @return Success
     */
    getPartnerSupportUsers(partnerId: number, type: PartnerSupportType | undefined): Observable<GetPartnerSupportUsersDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSupportUsers?';
        if (partnerId === undefined || partnerId === null) throw new Error("The parameter 'partnerId' must be defined and cannot be null.");
        else url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (type === null) throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSupportUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSupportUsers(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerSupportUsersDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerSupportUsersDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSupportUsers(response: HttpResponseBase): Observable<GetPartnerSupportUsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetPartnerSupportUsersDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerSupportUsersDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartnerSupport(body: CreateOrUpdatePartnerSupportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdatePartnerSupport';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerSupport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerSupport(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerSupport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePartnerDocument(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeletePartnerDocument?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartnerDocument(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartnerDocument(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartnerDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPartnerDocument(body: CreateOrUpdatePartnerDocumentInput | undefined): Observable<PartnerDocumentDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreatePartnerDocument';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreatePartnerDocument(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreatePartnerDocument(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerDocumentDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerDocumentDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreatePartnerDocument(response: HttpResponseBase): Observable<PartnerDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerDocumentDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerDocumentDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerUserReport(id: number | undefined): Observable<PartnerUserReport[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerUserReport?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerUserReport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerUserReport(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerUserReport[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerUserReport[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerUserReport(response: HttpResponseBase): Observable<PartnerUserReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerUserReport.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerUserReport[]>([]);
    }

    /**
     * @param salesAgentId (optional)
     * @param partnerId (optional)
     * @param filterInput (optional)
     * @return Success
     */
    getFilteredSalesAgentPartner(
        salesAgentId: number | undefined,
        partnerId: number | undefined,
        filterInput: string | undefined
    ): Observable<SalesAgentPartnerListForQuote> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetFilteredSalesAgentPartner?';
        if (salesAgentId === null) throw new Error("The parameter 'salesAgentId' cannot be null.");
        else if (salesAgentId !== undefined) url_ += 'SalesAgentId=' + encodeURIComponent('' + salesAgentId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (filterInput === null) throw new Error("The parameter 'filterInput' cannot be null.");
        else if (filterInput !== undefined) url_ += 'filterInput=' + encodeURIComponent('' + filterInput) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetFilteredSalesAgentPartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetFilteredSalesAgentPartner(<any>response_);
                        } catch (e) {
                            return <Observable<SalesAgentPartnerListForQuote>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesAgentPartnerListForQuote>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetFilteredSalesAgentPartner(response: HttpResponseBase): Observable<SalesAgentPartnerListForQuote> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SalesAgentPartnerListForQuote.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesAgentPartnerListForQuote>(<any>null);
    }

    /**
     * @param paramCustomerIdList (optional)
     * @return Success
     */
    getCustomerLocListByPartners(paramCustomerIdList: string | undefined): Observable<PartnerCustomerLocListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetCustomerLocListByPartners?';
        if (paramCustomerIdList === null) throw new Error("The parameter 'paramCustomerIdList' cannot be null.");
        else if (paramCustomerIdList !== undefined) url_ += 'paramCustomerIdList=' + encodeURIComponent('' + paramCustomerIdList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCustomerLocListByPartners(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCustomerLocListByPartners(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerCustomerLocListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerCustomerLocListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCustomerLocListByPartners(response: HttpResponseBase): Observable<PartnerCustomerLocListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerCustomerLocListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerCustomerLocListDto[]>([]);
    }

    /**
     * @param paramPartnerIdList (optional)
     * @return Success
     */
    getAgentListByPartners(paramPartnerIdList: string | undefined): Observable<GetSimpleAgentListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetAgentListByPartners?';
        if (paramPartnerIdList === null) throw new Error("The parameter 'paramPartnerIdList' cannot be null.");
        else if (paramPartnerIdList !== undefined) url_ += 'paramPartnerIdList=' + encodeURIComponent('' + paramPartnerIdList) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAgentListByPartners(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAgentListByPartners(<any>response_);
                        } catch (e) {
                            return <Observable<GetSimpleAgentListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetSimpleAgentListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAgentListByPartners(response: HttpResponseBase): Observable<GetSimpleAgentListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetSimpleAgentListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetSimpleAgentListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createPartnerFromOpportunity(body: CreatePartnerFromOpportunityInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreatePartnerFromOpportunity';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreatePartnerFromOpportunity(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreatePartnerFromOpportunity(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreatePartnerFromOpportunity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getPartnerSalesByProvider(providerId: number | undefined): Observable<GetPartnerSalesByProviderListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSalesByProvider?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSalesByProvider(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSalesByProvider(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerSalesByProviderListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerSalesByProviderListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSalesByProvider(response: HttpResponseBase): Observable<GetPartnerSalesByProviderListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetPartnerSalesByProviderListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerSalesByProviderListDto[]>([]);
    }

    /**
     * @param providerId (optional)
     * @return Success
     */
    getPartnerQuotesByProvider(providerId: number | undefined): Observable<GetPartnerQuotesByProviderListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerQuotesByProvider?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerQuotesByProvider(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerQuotesByProvider(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerQuotesByProviderListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerQuotesByProviderListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerQuotesByProvider(response: HttpResponseBase): Observable<GetPartnerQuotesByProviderListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetPartnerQuotesByProviderListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerQuotesByProviderListDto[]>([]);
    }

    /**
     * @return Success
     */
    getPartnerAcquisitionList(): Observable<PartnerAcquisitionListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerAcquisitionList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerAcquisitionList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerAcquisitionList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerAcquisitionListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerAcquisitionListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerAcquisitionList(response: HttpResponseBase): Observable<PartnerAcquisitionListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerAcquisitionListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerAcquisitionListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerSubAgencyList(id: number | undefined): Observable<PartnerSubAgencyListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSubAgencyList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSubAgencyList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSubAgencyList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerSubAgencyListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerSubAgencyListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSubAgencyList(response: HttpResponseBase): Observable<PartnerSubAgencyListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerSubAgencyListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerSubAgencyListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerSubAgencyByAgent(id: number | undefined): Observable<PartnerSubAgencyListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSubAgencyByAgent?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSubAgencyByAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSubAgencyByAgent(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerSubAgencyListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerSubAgencyListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSubAgencyByAgent(response: HttpResponseBase): Observable<PartnerSubAgencyListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerSubAgencyListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerSubAgencyListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartnerSubAgency(body: CreateOrUpdatePartnerSubAgencyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdatePartnerSubAgency';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerSubAgency(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerSubAgency(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerSubAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePartnerSubAgency(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeletePartnerSubAgency?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartnerSubAgency(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartnerSubAgency(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartnerSubAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPartnerSalesSupportList(id: number | undefined): Observable<PartnerSalesSupportListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerSalesSupportList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerSalesSupportList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerSalesSupportList(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerSalesSupportListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerSalesSupportListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerSalesSupportList(response: HttpResponseBase): Observable<PartnerSalesSupportListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(PartnerSalesSupportListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerSalesSupportListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdatePartnerSalesSupport(body: CreateOrUpdatePartnerSalesSupportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdatePartnerSalesSupport';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerSalesSupport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerSalesSupport(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerSalesSupport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deletePartnerSalesSupport(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeletePartnerSalesSupport?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartnerSalesSupport(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartnerSalesSupport(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartnerSalesSupport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isArchiveIncluded (optional)
     * @param partnerId (optional)
     * @param spmId (optional)
     * @return Success
     * @deprecated
     */
    getPartnerDevelopments(
        isArchiveIncluded: boolean | undefined,
        partnerId: number | undefined,
        spmId: number | undefined
    ): Observable<GetPartnerDevelopmentListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerDevelopments?';
        if (isArchiveIncluded === null) throw new Error("The parameter 'isArchiveIncluded' cannot be null.");
        else if (isArchiveIncluded !== undefined) url_ += 'isArchiveIncluded=' + encodeURIComponent('' + isArchiveIncluded) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerDevelopments(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerDevelopments(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerDevelopmentListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerDevelopmentListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerDevelopments(response: HttpResponseBase): Observable<GetPartnerDevelopmentListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(GetPartnerDevelopmentListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerDevelopmentListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    getPartnerDevelopmentForEdit(id: number | undefined): Observable<PartnerDevelopmentEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerDevelopmentForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerDevelopmentForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerDevelopmentForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<PartnerDevelopmentEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PartnerDevelopmentEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerDevelopmentForEdit(response: HttpResponseBase): Observable<PartnerDevelopmentEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PartnerDevelopmentEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PartnerDevelopmentEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     * @deprecated
     */
    deletePartnerDevelopment(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeletePartnerDevelopment?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeletePartnerDevelopment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeletePartnerDevelopment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeletePartnerDevelopment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    createOrUpdatePartnerDevelopment(body: CreateOrUpdatePartnerDevelopmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdatePartnerDevelopment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdatePartnerDevelopment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdatePartnerDevelopment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdatePartnerDevelopment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param spmId (optional)
     * @return Success
     * @deprecated
     */
    getPartnersForPartnerDevelopment(spmId: number | undefined): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnersForPartnerDevelopment?';
        if (spmId === null) throw new Error("The parameter 'spmId' cannot be null.");
        else if (spmId !== undefined) url_ += 'spmId=' + encodeURIComponent('' + spmId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnersForPartnerDevelopment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnersForPartnerDevelopment(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnersForPartnerDevelopment(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     * @deprecated
     */
    getPartnerUsersForPartnerDevelopment(partnerId: number | undefined): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerUsersForPartnerDevelopment?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerUsersForPartnerDevelopment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerUsersForPartnerDevelopment(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerUsersForPartnerDevelopment(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @param providerId (optional)
     * @return Success
     * @deprecated
     */
    getProviderUsersForPartnerDevelopment(providerId: number | undefined): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetProviderUsersForPartnerDevelopment?';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProviderUsersForPartnerDevelopment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProviderUsersForPartnerDevelopment(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProviderUsersForPartnerDevelopment(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getProvidersForPartnerDevelopment(): Observable<DropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetProvidersForPartnerDevelopment';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProvidersForPartnerDevelopment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProvidersForPartnerDevelopment(<any>response_);
                        } catch (e) {
                            return <Observable<DropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<DropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProvidersForPartnerDevelopment(response: HttpResponseBase): Observable<DropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(DropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<DropdownDto[]>([]);
    }

    /**
     * @return Success
     * @deprecated
     */
    getStatusList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetStatusList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStatusList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    updatePartnerDevelopmentStatus(body: UpdatePartnerDevelopmentStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/UpdatePartnerDevelopmentStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdatePartnerDevelopmentStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdatePartnerDevelopmentStatus(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdatePartnerDevelopmentStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     * @deprecated
     */
    clearPartnerDevelopmentCache(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/ClearPartnerDevelopmentCache';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processClearPartnerDevelopmentCache(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processClearPartnerDevelopmentCache(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processClearPartnerDevelopmentCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param statusId (optional)
     * @return Success
     * @deprecated
     */
    getPartnerDevelopmentStatusName(statusId: number | undefined): Observable<GetPartnerDevelopmentStatusNameDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetPartnerDevelopmentStatusName?';
        if (statusId === null) throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined) url_ += 'statusId=' + encodeURIComponent('' + statusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerDevelopmentStatusName(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerDevelopmentStatusName(<any>response_);
                        } catch (e) {
                            return <Observable<GetPartnerDevelopmentStatusNameDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetPartnerDevelopmentStatusNameDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerDevelopmentStatusName(response: HttpResponseBase): Observable<GetPartnerDevelopmentStatusNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetPartnerDevelopmentStatusNameDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetPartnerDevelopmentStatusNameDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAdvisorEntitlements(): Observable<AdvisorEntitlementDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetAdvisorEntitlements';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdvisorEntitlements(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdvisorEntitlements(<any>response_);
                        } catch (e) {
                            return <Observable<AdvisorEntitlementDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdvisorEntitlementDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdvisorEntitlements(response: HttpResponseBase): Observable<AdvisorEntitlementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdvisorEntitlementDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdvisorEntitlementDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAdvisorEntitlement(id: number | undefined): Observable<AdvisorEntitlementDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetAdvisorEntitlement?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdvisorEntitlement(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdvisorEntitlement(<any>response_);
                        } catch (e) {
                            return <Observable<AdvisorEntitlementDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdvisorEntitlementDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdvisorEntitlement(response: HttpResponseBase): Observable<AdvisorEntitlementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdvisorEntitlementDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdvisorEntitlementDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAdvisorEntitlement(body: AdvisorEntitlementDto | undefined): Observable<AdvisorEntitlementDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/CreateOrUpdateAdvisorEntitlement';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateAdvisorEntitlement(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateAdvisorEntitlement(<any>response_);
                        } catch (e) {
                            return <Observable<AdvisorEntitlementDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdvisorEntitlementDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateAdvisorEntitlement(response: HttpResponseBase): Observable<AdvisorEntitlementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdvisorEntitlementDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdvisorEntitlementDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteAdvisorEntitlement(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Partner/DeleteAdvisorEntitlement?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteAdvisorEntitlement(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteAdvisorEntitlement(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteAdvisorEntitlement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param advisorId (optional)
     * @return Success
     */
    getAdvisorEntitlementByAdvisorId(advisorId: number | undefined): Observable<AdvisorEntitlementDto> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetAdvisorEntitlementByAdvisorId?';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAdvisorEntitlementByAdvisorId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAdvisorEntitlementByAdvisorId(<any>response_);
                        } catch (e) {
                            return <Observable<AdvisorEntitlementDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdvisorEntitlementDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAdvisorEntitlementByAdvisorId(response: HttpResponseBase): Observable<AdvisorEntitlementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AdvisorEntitlementDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdvisorEntitlementDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSupportContacts(): Observable<{ [key: string]: SupportContactDto[] }> {
        let url_ = this.baseUrl + '/api/services/app/Partner/GetSupportContacts';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSupportContacts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSupportContacts(<any>response_);
                        } catch (e) {
                            return <Observable<{ [key: string]: SupportContactDto[] }>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<{ [key: string]: SupportContactDto[] }>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSupportContacts(response: HttpResponseBase): Observable<{ [key: string]: SupportContactDto[] }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (resultData200) {
                        result200 = {} as any;
                        for (let key in resultData200) {
                            if (resultData200.hasOwnProperty(key))
                                result200[key] = resultData200[key] ? resultData200[key].map((i: any) => SupportContactDto.fromJS(i)) : [];
                        }
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<{ [key: string]: SupportContactDto[] }>(<any>null);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getProductList(): Observable<ProductListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductList(<any>response_);
                        } catch (e) {
                            return <Observable<ProductListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductList(response: HttpResponseBase): Observable<ProductListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProductsByCategory(id: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductsByCategory?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductsByCategory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductsByCategory(<any>response_);
                        } catch (e) {
                            return <Observable<number[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductsByCategory(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number[]>([]);
    }

    /**
     * @param categoryIds (optional)
     * @return Success
     */
    getProductsByCategories(categoryIds: number[] | undefined): Observable<ProductListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductsByCategories?';
        if (categoryIds === null) throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds &&
                categoryIds.forEach((item) => {
                    url_ += 'categoryIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductsByCategories(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductsByCategories(<any>response_);
                        } catch (e) {
                            return <Observable<ProductListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductsByCategories(response: HttpResponseBase): Observable<ProductListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductListDto[]>([]);
    }

    /**
     * @param filter (optional)
     * @param categoryName (optional)
     * @return Success
     */
    getProductsForService(filter: string | undefined, categoryName: string | undefined): Observable<ProductListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductsForService?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (categoryName === null) throw new Error("The parameter 'categoryName' cannot be null.");
        else if (categoryName !== undefined) url_ += 'CategoryName=' + encodeURIComponent('' + categoryName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductsForService(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductsForService(<any>response_);
                        } catch (e) {
                            return <Observable<ProductListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductsForService(response: HttpResponseBase): Observable<ProductListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductListDto[]>([]);
    }

    /**
     * @param filter (optional)
     * @param categoryName (optional)
     * @param forceCacheRefresh (optional)
     * @return Success
     */
    getProducts(
        filter: string | undefined,
        categoryName: string | undefined,
        forceCacheRefresh: boolean | undefined
    ): Observable<ProductListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProducts?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (categoryName === null) throw new Error("The parameter 'categoryName' cannot be null.");
        else if (categoryName !== undefined) url_ += 'CategoryName=' + encodeURIComponent('' + categoryName) + '&';
        if (forceCacheRefresh === null) throw new Error("The parameter 'forceCacheRefresh' cannot be null.");
        else if (forceCacheRefresh !== undefined) url_ += 'forceCacheRefresh=' + encodeURIComponent('' + forceCacheRefresh) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProducts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProducts(<any>response_);
                        } catch (e) {
                            return <Observable<ProductListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProducts(response: HttpResponseBase): Observable<ProductListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductListDto[]>([]);
    }

    /**
     * @return Success
     */
    getProductsToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductsToExcel';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductsToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductsToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProductForEdit(id: number | undefined): Observable<GetProductForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetProductForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProductForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductForEdit(response: HttpResponseBase): Observable<GetProductForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProductForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProductForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProductCategoryList(): Observable<ProductCategoryListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductCategoryList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductCategoryList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductCategoryList(<any>response_);
                        } catch (e) {
                            return <Observable<ProductCategoryListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductCategoryListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductCategoryList(response: HttpResponseBase): Observable<ProductCategoryListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductCategoryListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductCategoryListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProductMilestoneList(id: number | undefined): Observable<GetProductMilestoneListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductMilestoneList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductMilestoneList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductMilestoneList(<any>response_);
                        } catch (e) {
                            return <Observable<GetProductMilestoneListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProductMilestoneListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductMilestoneList(response: HttpResponseBase): Observable<GetProductMilestoneListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProductMilestoneListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProductMilestoneListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param productId (optional)
     * @return Success
     */
    getProductMilestoneSortedByIsAssignedList(
        productId: number | undefined
    ): Observable<GetProductMilestoneSortedByIsAssignedOutputPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductMilestoneSortedByIsAssignedList?';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductMilestoneSortedByIsAssignedList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductMilestoneSortedByIsAssignedList(<any>response_);
                        } catch (e) {
                            return <Observable<GetProductMilestoneSortedByIsAssignedOutputPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProductMilestoneSortedByIsAssignedOutputPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductMilestoneSortedByIsAssignedList(
        response: HttpResponseBase
    ): Observable<GetProductMilestoneSortedByIsAssignedOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProductMilestoneSortedByIsAssignedOutputPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProductMilestoneSortedByIsAssignedOutputPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProductMilestone(body: CreateOrUpdateProductMilestoneInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/CreateOrUpdateProductMilestone';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProductMilestone(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProductMilestone(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProductMilestone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProductMilestone(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/DeleteProductMilestone?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProductMilestone(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProductMilestone(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProductMilestone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProduct(body: CreateOrUpdateProductInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Product/CreateOrUpdateProduct';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProduct(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProduct(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProduct(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProduct(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/DeleteProduct?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProduct(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProduct(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getProductAttributeList(): Observable<ProductAttributeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductAttributeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductAttributeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductAttributeList(<any>response_);
                        } catch (e) {
                            return <Observable<ProductAttributeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductAttributeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductAttributeList(response: HttpResponseBase): Observable<ProductAttributeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductAttributeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductAttributeListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProductAttribute(body: CreateOrUpdateProductAttributeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/CreateOrUpdateProductAttribute';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProductAttribute(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProductAttribute(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProductAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProductAttribute(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/DeleteProductAttribute?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProductAttribute(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProductAttribute(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProductAttribute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param productId (optional)
     * @return Success
     */
    getProductAttributeTypeSortedByIsAssignedList(
        productId: number | undefined
    ): Observable<GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductAttributeTypeSortedByIsAssignedList?';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'ProductId=' + encodeURIComponent('' + productId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductAttributeTypeSortedByIsAssignedList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductAttributeTypeSortedByIsAssignedList(<any>response_);
                        } catch (e) {
                            return <Observable<GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else
                        return <Observable<GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto>>(
                            (<any>_observableThrow(response_))
                        );
                })
            );
    }

    protected processGetProductAttributeTypeSortedByIsAssignedList(
        response: HttpResponseBase
    ): Observable<GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProductAttributeTypeSortedByIsAssignedOutputPagedResultDto>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getProductAttributeTypes(filter: string | undefined): Observable<ProductAttributeTypeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductAttributeTypes?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductAttributeTypes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductAttributeTypes(<any>response_);
                        } catch (e) {
                            return <Observable<ProductAttributeTypeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductAttributeTypeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductAttributeTypes(response: HttpResponseBase): Observable<ProductAttributeTypeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductAttributeTypeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductAttributeTypeListDto[]>([]);
    }

    /**
     * @return Success
     */
    getFieldTypeList(): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetFieldTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetFieldTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetFieldTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetFieldTypeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProductAttributeType(body: CreateOrUpdateProductAttributeTypeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/CreateOrUpdateProductAttributeType';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProductAttributeType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProductAttributeType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProductAttributeType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteProductAttributeType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/DeleteProductAttributeType?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteProductAttributeType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteProductAttributeType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteProductAttributeType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProductAttributeTypesForEdit(id: number | undefined): Observable<GetProductAttributeTypesForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductAttributeTypesForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductAttributeTypesForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductAttributeTypesForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetProductAttributeTypesForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProductAttributeTypesForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductAttributeTypesForEdit(response: HttpResponseBase): Observable<GetProductAttributeTypesForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProductAttributeTypesForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProductAttributeTypesForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getProductCategoryAdminList(filter: string | undefined): Observable<ProductCategoryAdminListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductCategoryAdminList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductCategoryAdminList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductCategoryAdminList(<any>response_);
                        } catch (e) {
                            return <Observable<ProductCategoryAdminListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductCategoryAdminListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductCategoryAdminList(response: HttpResponseBase): Observable<ProductCategoryAdminListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(ProductCategoryAdminListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductCategoryAdminListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getProductCategoriesForEdit(id: number | undefined): Observable<ProductCategoryAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Product/GetProductCategoriesForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProductCategoriesForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProductCategoriesForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<ProductCategoryAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ProductCategoryAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProductCategoriesForEdit(response: HttpResponseBase): Observable<ProductCategoryAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ProductCategoryAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ProductCategoryAdminEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteCategory(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/DeleteCategory?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteCategory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteCategory(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateProductCategory(body: CreateOrUpdateProductCategoryInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Product/CreateOrUpdateProductCategory';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateProductCategory(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateProductCategory(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateProductCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SalesCampaignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getSalesCampaignById(id: number | undefined): Observable<SalesCampaignDto> {
        let url_ = this.baseUrl + '/api/services/app/SalesCampaign/GetSalesCampaignById?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesCampaignById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesCampaignById(<any>response_);
                        } catch (e) {
                            return <Observable<SalesCampaignDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesCampaignDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesCampaignById(response: HttpResponseBase): Observable<SalesCampaignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SalesCampaignDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesCampaignDto>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getSalesCampaignsByPartnerId(partnerId: number | undefined): Observable<SalesCampaignDto[]> {
        let url_ = this.baseUrl + '/api/services/app/SalesCampaign/GetSalesCampaignsByPartnerId?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesCampaignsByPartnerId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesCampaignsByPartnerId(<any>response_);
                        } catch (e) {
                            return <Observable<SalesCampaignDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesCampaignDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesCampaignsByPartnerId(response: HttpResponseBase): Observable<SalesCampaignDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesCampaignDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesCampaignDto[]>([]);
    }

    /**
     * @param campaignName (optional)
     * @param advisorId (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param campaignType (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getSalesCampaignPagedResult(
        campaignName: string | undefined,
        advisorId: number | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        campaignType: CampaignType | undefined,
        sorting: string | undefined,
        skipCount: number | undefined,
        maxResultCount: number | undefined
    ): Observable<SalesCampaignDtoPagedResultModel> {
        let url_ = this.baseUrl + '/api/services/app/SalesCampaign/GetSalesCampaignPagedResult?';
        if (campaignName === null) throw new Error("The parameter 'campaignName' cannot be null.");
        else if (campaignName !== undefined) url_ += 'campaignName=' + encodeURIComponent('' + campaignName) + '&';
        if (advisorId === null) throw new Error("The parameter 'advisorId' cannot be null.");
        else if (advisorId !== undefined) url_ += 'advisorId=' + encodeURIComponent('' + advisorId) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (campaignType === null) throw new Error("The parameter 'campaignType' cannot be null.");
        else if (campaignType !== undefined) url_ += 'campaignType=' + encodeURIComponent('' + campaignType) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'sorting=' + encodeURIComponent('' + sorting) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'skipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'maxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesCampaignPagedResult(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesCampaignPagedResult(<any>response_);
                        } catch (e) {
                            return <Observable<SalesCampaignDtoPagedResultModel>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesCampaignDtoPagedResultModel>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesCampaignPagedResult(response: HttpResponseBase): Observable<SalesCampaignDtoPagedResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = SalesCampaignDtoPagedResultModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesCampaignDtoPagedResultModel>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateSalesCampaign(body: SalesCampaignCreateEditInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/SalesCampaign/CreateOrUpdateSalesCampaign';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateSalesCampaign(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateSalesCampaign(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateSalesCampaign(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    hasExistingOrdersOrQuotes(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/SalesCampaign/HasExistingOrdersOrQuotes?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processHasExistingOrdersOrQuotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processHasExistingOrdersOrQuotes(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processHasExistingOrdersOrQuotes(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/GetAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllSettings(<any>response_);
                        } catch (e) {
                            return <Observable<TenantSettingsEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantSettingsEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantSettingsEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPublicSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/GetPublicSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPublicSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPublicSettings(<any>response_);
                        } catch (e) {
                            return <Observable<TenantSettingsEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TenantSettingsEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPublicSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TenantSettingsEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySettings(): Observable<PasswordComplexitySetting> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/GetPasswordComplexitySettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPasswordComplexitySettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPasswordComplexitySettings(<any>response_);
                        } catch (e) {
                            return <Observable<PasswordComplexitySetting>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PasswordComplexitySetting>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPasswordComplexitySettings(response: HttpResponseBase): Observable<PasswordComplexitySetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PasswordComplexitySetting.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PasswordComplexitySetting>(<any>null);
    }

    /**
     * @return Success
     */
    getAppTitle(): Observable<string> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/GetAppTitle';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAppTitle(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAppTitle(<any>response_);
                        } catch (e) {
                            return <Observable<string>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAppTitle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/UpdateAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateAllSettings(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateAllSettings(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional)
     * @param userKey (optional)
     * @param integration (optional)
     * @return Success
     */
    createIntegrationUserKey(
        userId: number | undefined,
        userKey: string | undefined,
        integration: string | undefined
    ): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/CreateIntegrationUserKey?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        if (userKey === null) throw new Error("The parameter 'userKey' cannot be null.");
        else if (userKey !== undefined) url_ += 'userKey=' + encodeURIComponent('' + userKey) + '&';
        if (integration === null) throw new Error("The parameter 'integration' cannot be null.");
        else if (integration !== undefined) url_ += 'integration=' + encodeURIComponent('' + integration) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateIntegrationUserKey(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateIntegrationUserKey(<any>response_);
                        } catch (e) {
                            return <Observable<boolean>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<boolean>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateIntegrationUserKey(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    carrierFinderProxy(body: CarrierFinderProxyDto | undefined): Observable<CarrierFinderProxyOutputDto> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/CarrierFinderProxy';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCarrierFinderProxy(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCarrierFinderProxy(<any>response_);
                        } catch (e) {
                            return <Observable<CarrierFinderProxyOutputDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CarrierFinderProxyOutputDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCarrierFinderProxy(response: HttpResponseBase): Observable<CarrierFinderProxyOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CarrierFinderProxyOutputDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CarrierFinderProxyOutputDto>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getUser(input: number | undefined): Observable<GetUserInfoOutput> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUser?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUser(<any>response_);
                        } catch (e) {
                            return <Observable<GetUserInfoOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUserInfoOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUser(response: HttpResponseBase): Observable<GetUserInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetUserInfoOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUserInfoOutput>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param permission (optional)
     * @param role (optional)
     * @param partnerId (optional)
     * @param providerId (optional)
     * @param activeStatus (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUsers(
        filter: string | undefined,
        permission: string | undefined,
        role: number | undefined,
        partnerId: number | undefined,
        providerId: number | undefined,
        activeStatus: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<UserListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsers?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (permission === null) throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined) url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
        if (role === null) throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined) url_ += 'Role=' + encodeURIComponent('' + role) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (activeStatus === null) throw new Error("The parameter 'activeStatus' cannot be null.");
        else if (activeStatus !== undefined) url_ += 'ActiveStatus=' + encodeURIComponent('' + activeStatus) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsers(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserListDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDtoPagedResultDto>(<any>null);
    }

    /**
     * @param query (optional)
     * @return Success
     */
    getUsersForDropdown(query: string | undefined): Observable<UserDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsersForDropdown?';
        if (query === null) throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersForDropdown(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersForDropdown(<any>response_);
                        } catch (e) {
                            return <Observable<UserDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersForDropdown(response: HttpResponseBase): Observable<UserDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDropdownDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserForDropdown(id: number | undefined): Observable<UserDropdownDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserForDropdown?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserForDropdown(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserForDropdown(<any>response_);
                        } catch (e) {
                            return <Observable<UserDropdownDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserDropdownDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserForDropdown(response: HttpResponseBase): Observable<UserDropdownDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDropdownDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDropdownDto>(<any>null);
    }

    /**
     * @param departmentIds (optional)
     * @return Success
     */
    getUsersForDropdownByDepartment(departmentIds: number[] | undefined): Observable<UserDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsersForDropdownByDepartment?';
        if (departmentIds === null) throw new Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined)
            departmentIds &&
                departmentIds.forEach((item) => {
                    url_ += 'departmentIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersForDropdownByDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersForDropdownByDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<UserDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersForDropdownByDepartment(response: HttpResponseBase): Observable<UserDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDropdownDto[]>([]);
    }

    /**
     * @return Success
     */
    getInternalUsers(): Observable<UserDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetInternalUsers';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInternalUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInternalUsers(<any>response_);
                        } catch (e) {
                            return <Observable<UserDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetInternalUsers(response: HttpResponseBase): Observable<UserDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDropdownDto[]>([]);
    }

    /**
     * @param filter (optional)
     * @param permission (optional)
     * @param role (optional)
     * @param partnerId (optional)
     * @param providerId (optional)
     * @param activeStatus (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUsersToExcel(
        filter: string | undefined,
        permission: string | undefined,
        role: number | undefined,
        partnerId: number | undefined,
        providerId: number | undefined,
        activeStatus: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsersToExcel?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (permission === null) throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined) url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
        if (role === null) throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined) url_ += 'Role=' + encodeURIComponent('' + role) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (activeStatus === null) throw new Error("The parameter 'activeStatus' cannot be null.");
        else if (activeStatus !== undefined) url_ += 'ActiveStatus=' + encodeURIComponent('' + activeStatus) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetUserForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUserForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetUserForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUserForEditOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserPermissionsForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserPermissionsForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserPermissionsForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetUserPermissionsForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetUserPermissionsForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetUserSpecificPermissions(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/ResetUserSpecificPermissions';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processResetUserSpecificPermissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processResetUserSpecificPermissions(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/UpdateUserPermissions';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateUserPermissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateUserPermissions(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/ChangeLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processChangeLanguage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processChangeLanguage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/UpdateUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param firstName (optional)
     * @param lastName (optional)
     * @param phone (optional)
     * @param email (optional)
     * @param partnerId (optional)
     * @return Success
     */
    createPartnerContactUser(
        firstName: string | undefined,
        lastName: string | undefined,
        phone: string | undefined,
        email: string | undefined,
        partnerId: number | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/CreatePartnerContactUser?';
        if (firstName === null) throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined) url_ += 'firstName=' + encodeURIComponent('' + firstName) + '&';
        if (lastName === null) throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined) url_ += 'lastName=' + encodeURIComponent('' + lastName) + '&';
        if (phone === null) throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined) url_ += 'phone=' + encodeURIComponent('' + phone) + '&';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreatePartnerContactUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreatePartnerContactUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreatePartnerContactUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    fillRoleNames(body: UserListDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/FillRoleNames';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processFillRoleNames(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processFillRoleNames(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processFillRoleNames(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getSalesEngineerList(input: string | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSalesEngineerList?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesEngineerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesEngineerList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesEngineerList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @param input (optional)
     * @return Success
     */
    getSalesAgentList(id: number | undefined, input: string | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSalesAgentList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesAgentList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesAgentList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesAgentList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param partnerIds (optional)
     * @return Success
     */
    getSalesAgentsByPartnerList(partnerIds: number[] | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSalesAgentsByPartnerList?';
        if (partnerIds === null) throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds &&
                partnerIds.forEach((item) => {
                    url_ += 'partnerIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesAgentsByPartnerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesAgentsByPartnerList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesAgentsByPartnerList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getInvestOwnerUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetInvestOwnerUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInvestOwnerUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInvestOwnerUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetInvestOwnerUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getSupportUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSupportUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSupportUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSupportUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSupportUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getOrderSupportUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetOrderSupportUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderSupportUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderSupportUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderSupportUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getSalesSupportUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSalesSupportUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesSupportUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesSupportUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesSupportUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getStrategicPartnerManagerUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetStrategicPartnerManagerUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetStrategicPartnerManagerUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetStrategicPartnerManagerUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetStrategicPartnerManagerUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getPartnerManagerUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetPartnerManagerUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetPartnerManagerUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetPartnerManagerUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetPartnerManagerUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getCommissionManagerList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetCommissionManagerList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionManagerList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionManagerList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionManagerList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getSalesSupportSupervisorList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSalesSupportSupervisorList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesSupportSupervisorList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesSupportSupervisorList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesSupportSupervisorList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getOrderSupportSupervisorList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetOrderSupportSupervisorList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOrderSupportSupervisorList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOrderSupportSupervisorList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOrderSupportSupervisorList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getSupervisorUsers(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetSupervisorUsers';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSupervisorUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSupervisorUsers(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSupervisorUsers(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getOpportunityUserList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetOpportunityUserList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpportunityUserList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpportunityUserList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpportunityUserList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param roleIds (optional)
     * @return Success
     */
    getUsersByRoles(roleIds: number[] | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsersByRoles?';
        if (roleIds === null) throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds &&
                roleIds.forEach((item) => {
                    url_ += 'roleIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersByRoles(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersByRoles(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersByRoles(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @return Success
     */
    getUserRoleDetail(): Observable<UserDetailOutput> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserRoleDetail';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUserRoleDetail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUserRoleDetail(<any>response_);
                        } catch (e) {
                            return <Observable<UserDetailOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserDetailOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUserRoleDetail(response: HttpResponseBase): Observable<UserDetailOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserDetailOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserDetailOutput>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getContactIdFromUser(input: number | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/User/GetContactIdFromUser?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactIdFromUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactIdFromUser(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactIdFromUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getInternalSalesAgentsList(): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetInternalSalesAgentsList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetInternalSalesAgentsList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetInternalSalesAgentsList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetInternalSalesAgentsList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param month (optional)
     * @param year (optional)
     * @return Success
     */
    getCommissionProviderImportUploaders(month: number | undefined, year: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetCommissionProviderImportUploaders?';
        if (month === null) throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined) url_ += 'month=' + encodeURIComponent('' + month) + '&';
        if (year === null) throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCommissionProviderImportUploaders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCommissionProviderImportUploaders(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCommissionProviderImportUploaders(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }
}

export enum ActivityCategory {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum ActivityType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class AdvisorEntitlementDto implements IAdvisorEntitlementDto {
    name: string;
    foregroundColor: string;
    backgroundColor: string;
    isEnabled: boolean;
    id: number;

    constructor(data?: IAdvisorEntitlementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.foregroundColor = _data['foregroundColor'];
            this.backgroundColor = _data['backgroundColor'];
            this.isEnabled = _data['isEnabled'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): AdvisorEntitlementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvisorEntitlementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['foregroundColor'] = this.foregroundColor;
        data['backgroundColor'] = this.backgroundColor;
        data['isEnabled'] = this.isEnabled;
        data['id'] = this.id;
        return data;
    }

    clone(): AdvisorEntitlementDto {
        const json = this.toJSON();
        let result = new AdvisorEntitlementDto();
        result.init(json);
        return result;
    }
}

export class BackgroundJobExecutionDto implements IBackgroundJobExecutionDto {
    id: number;
    uuid: string;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    source: string | undefined;
    status: BackgroundJobExecutionStatus;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    failureReason: string | undefined;
    metadata: string | undefined;
    jobResult: string | undefined;
    cancellationRequests: BackgroundJobCancellationRequestDto[] | undefined;
    output: BackgroundJobOutputDto;
    creatorFirstName: string | undefined;
    creatorLastName: string | undefined;

    constructor(data?: IBackgroundJobExecutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.uuid = _data['uuid'];
            this.creatorUserId = _data['creatorUserId'];
            this.tenantId = _data['tenantId'];
            this.source = _data['source'];
            this.status = _data['status'];
            this.startTime = _data['startTime'] ? moment(_data['startTime'].toString()) : <any>undefined;
            this.endTime = _data['endTime'] ? moment(_data['endTime'].toString()) : <any>undefined;
            this.failureReason = _data['failureReason'];
            this.metadata = _data['metadata'];
            this.jobResult = _data['jobResult'];
            if (Array.isArray(_data['cancellationRequests'])) {
                this.cancellationRequests = [] as any;
                for (let item of _data['cancellationRequests'])
                    this.cancellationRequests.push(BackgroundJobCancellationRequestDto.fromJS(item));
            }
            this.output = _data['output'] ? BackgroundJobOutputDto.fromJS(_data['output']) : <any>undefined;
            this.creatorFirstName = _data['creatorFirstName'];
            this.creatorLastName = _data['creatorLastName'];
        }
    }

    static fromJS(data: any): BackgroundJobExecutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobExecutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['uuid'] = this.uuid;
        data['creatorUserId'] = this.creatorUserId;
        data['tenantId'] = this.tenantId;
        data['source'] = this.source;
        data['status'] = this.status;
        data['startTime'] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data['endTime'] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data['failureReason'] = this.failureReason;
        data['metadata'] = this.metadata;
        data['jobResult'] = this.jobResult;
        if (Array.isArray(this.cancellationRequests)) {
            data['cancellationRequests'] = [];
            for (let item of this.cancellationRequests) data['cancellationRequests'].push(item.toJSON());
        }
        data['output'] = this.output ? this.output.toJSON() : <any>undefined;
        data['creatorFirstName'] = this.creatorFirstName;
        data['creatorLastName'] = this.creatorLastName;
        return data;
    }

    clone(): BackgroundJobExecutionDto {
        const json = this.toJSON();
        let result = new BackgroundJobExecutionDto();
        result.init(json);
        return result;
    }
}

export class ContactEditDto implements IContactEditDto {
    tenantId: number | undefined;
    title: string | undefined;
    department: string | undefined;
    firstName: string;
    lastName: string;
    email: string | undefined;
    workNumber: string | undefined;
    mobileNumber: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipcode: string | undefined;
    contactStatus: ContactStatus;
    contactType: ContactAccountType;
    contactAccountKey: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    contactAccountName: string | undefined;
    createdBy: string | undefined;
    creationTime: moment.Moment;
    contactContactGroupIds: number[] | undefined;
    contactRegions: string[] | undefined;
    jobDescription: string | undefined;
    parentId: number | undefined;
    order: number;
    userId: number | undefined;
    profilePictureId: string | undefined;
    id: number;

    constructor(data?: IContactEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.title = _data['title'];
            this.department = _data['department'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.email = _data['email'];
            this.workNumber = _data['workNumber'];
            this.mobileNumber = _data['mobileNumber'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.contactStatus = _data['contactStatus'];
            this.contactType = _data['contactType'];
            this.contactAccountKey = _data['contactAccountKey'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.contactAccountName = _data['contactAccountName'];
            this.createdBy = _data['createdBy'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['contactContactGroupIds'])) {
                this.contactContactGroupIds = [] as any;
                for (let item of _data['contactContactGroupIds']) this.contactContactGroupIds.push(item);
            }
            if (Array.isArray(_data['contactRegions'])) {
                this.contactRegions = [] as any;
                for (let item of _data['contactRegions']) this.contactRegions.push(item);
            }
            this.jobDescription = _data['jobDescription'];
            this.parentId = _data['parentId'];
            this.order = _data['order'];
            this.userId = _data['userId'];
            this.profilePictureId = _data['profilePictureId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContactEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['title'] = this.title;
        data['department'] = this.department;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['email'] = this.email;
        data['workNumber'] = this.workNumber;
        data['mobileNumber'] = this.mobileNumber;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['contactStatus'] = this.contactStatus;
        data['contactType'] = this.contactType;
        data['contactAccountKey'] = this.contactAccountKey;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['contactAccountName'] = this.contactAccountName;
        data['createdBy'] = this.createdBy;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.contactContactGroupIds)) {
            data['contactContactGroupIds'] = [];
            for (let item of this.contactContactGroupIds) data['contactContactGroupIds'].push(item);
        }
        if (Array.isArray(this.contactRegions)) {
            data['contactRegions'] = [];
            for (let item of this.contactRegions) data['contactRegions'].push(item);
        }
        data['jobDescription'] = this.jobDescription;
        data['parentId'] = this.parentId;
        data['order'] = this.order;
        data['userId'] = this.userId;
        data['profilePictureId'] = this.profilePictureId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContactEditDto {
        const json = this.toJSON();
        let result = new ContactEditDto();
        result.init(json);
        return result;
    }
}

export class ContactListDto implements IContactListDto {
    title: string | undefined;
    department: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    workNumber: string | undefined;
    mobileNumber: string | undefined;
    contactStatus: ContactStatus;
    contactType: ContactAccountType;
    contactAccountKey: number;
    contactAccountName: string | undefined;
    createdBy: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContactListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data['title'];
            this.department = _data['department'];
            this.firstName = _data['firstName'];
            this.lastName = _data['lastName'];
            this.email = _data['email'];
            this.workNumber = _data['workNumber'];
            this.mobileNumber = _data['mobileNumber'];
            this.contactStatus = _data['contactStatus'];
            this.contactType = _data['contactType'];
            this.contactAccountKey = _data['contactAccountKey'];
            this.contactAccountName = _data['contactAccountName'];
            this.createdBy = _data['createdBy'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContactListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['title'] = this.title;
        data['department'] = this.department;
        data['firstName'] = this.firstName;
        data['lastName'] = this.lastName;
        data['email'] = this.email;
        data['workNumber'] = this.workNumber;
        data['mobileNumber'] = this.mobileNumber;
        data['contactStatus'] = this.contactStatus;
        data['contactType'] = this.contactType;
        data['contactAccountKey'] = this.contactAccountKey;
        data['contactAccountName'] = this.contactAccountName;
        data['createdBy'] = this.createdBy;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContactListDto {
        const json = this.toJSON();
        let result = new ContactListDto();
        result.init(json);
        return result;
    }
}

export class CreateOrUpdateActivityInput implements ICreateOrUpdateActivityInput {
    activity: ActivityEditDto;
    userIdList: number[] | undefined;
    simpleActivityFlag: boolean;
    sendNotification: boolean;
    updateDetailAndDueDate: boolean;

    constructor(data?: ICreateOrUpdateActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.activity = new ActivityEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data['activity'] ? ActivityEditDto.fromJS(_data['activity']) : new ActivityEditDto();
            if (Array.isArray(_data['userIdList'])) {
                this.userIdList = [] as any;
                for (let item of _data['userIdList']) this.userIdList.push(item);
            }
            this.simpleActivityFlag = _data['simpleActivityFlag'];
            this.sendNotification = _data['sendNotification'];
            this.updateDetailAndDueDate = _data['updateDetailAndDueDate'];
        }
    }

    static fromJS(data: any): CreateOrUpdateActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['activity'] = this.activity ? this.activity.toJSON() : <any>undefined;
        if (Array.isArray(this.userIdList)) {
            data['userIdList'] = [];
            for (let item of this.userIdList) data['userIdList'].push(item);
        }
        data['simpleActivityFlag'] = this.simpleActivityFlag;
        data['sendNotification'] = this.sendNotification;
        data['updateDetailAndDueDate'] = this.updateDetailAndDueDate;
        return data;
    }

    clone(): CreateOrUpdateActivityInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateActivityInput();
        result.init(json);
        return result;
    }
}

export class DocumentListDto implements IDocumentListDto {
    documentName: string | undefined;
    providerId: number;
    documentType: DocumentType;
    key: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
    uuid: string;

    constructor(data?: IDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data['documentName'];
            this.providerId = _data['providerId'];
            this.documentType = _data['documentType'];
            this.key = _data['key'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
            this.uuid = _data['uuid'];
        }
    }

    static fromJS(data: any): DocumentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['documentName'] = this.documentName;
        data['providerId'] = this.providerId;
        data['documentType'] = this.documentType;
        data['key'] = this.key;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        data['uuid'] = this.uuid;
        return data;
    }

    clone(): DocumentListDto {
        const json = this.toJSON();
        let result = new DocumentListDto();
        result.init(json);
        return result;
    }
}

export class EmailDetailInput implements IEmailDetailInput {
    from: string | undefined;
    subject: string | undefined;
    mailToList: string[] | undefined;
    mailCcList: string[] | undefined;
    mailBccList: string[] | undefined;
    body: string | undefined;
    documents: DocumentListDto[] | undefined;
    unsubscribeGroup: string | undefined;
    emailType: OnDemandEmailType;

    constructor(data?: IEmailDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data['from'];
            this.subject = _data['subject'];
            if (Array.isArray(_data['mailToList'])) {
                this.mailToList = [] as any;
                for (let item of _data['mailToList']) this.mailToList.push(item);
            }
            if (Array.isArray(_data['mailCcList'])) {
                this.mailCcList = [] as any;
                for (let item of _data['mailCcList']) this.mailCcList.push(item);
            }
            if (Array.isArray(_data['mailBccList'])) {
                this.mailBccList = [] as any;
                for (let item of _data['mailBccList']) this.mailBccList.push(item);
            }
            this.body = _data['body'];
            if (Array.isArray(_data['documents'])) {
                this.documents = [] as any;
                for (let item of _data['documents']) this.documents.push(DocumentListDto.fromJS(item));
            }
            this.unsubscribeGroup = _data['unsubscribeGroup'];
            this.emailType = _data['emailType'];
        }
    }

    static fromJS(data: any): EmailDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['from'] = this.from;
        data['subject'] = this.subject;
        if (Array.isArray(this.mailToList)) {
            data['mailToList'] = [];
            for (let item of this.mailToList) data['mailToList'].push(item);
        }
        if (Array.isArray(this.mailCcList)) {
            data['mailCcList'] = [];
            for (let item of this.mailCcList) data['mailCcList'].push(item);
        }
        if (Array.isArray(this.mailBccList)) {
            data['mailBccList'] = [];
            for (let item of this.mailBccList) data['mailBccList'].push(item);
        }
        data['body'] = this.body;
        if (Array.isArray(this.documents)) {
            data['documents'] = [];
            for (let item of this.documents) data['documents'].push(item.toJSON());
        }
        data['unsubscribeGroup'] = this.unsubscribeGroup;
        data['emailType'] = this.emailType;
        return data;
    }

    clone(): EmailDetailInput {
        const json = this.toJSON();
        let result = new EmailDetailInput();
        result.init(json);
        return result;
    }
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.fileType = _data['fileType'];
            this.fileToken = _data['fileToken'];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['fileType'] = this.fileType;
        data['fileToken'] = this.fileToken;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export class GuidEntityDto implements IGuidEntityDto {
    id: string;

    constructor(data?: IGuidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }

    clone(): GuidEntityDto {
        const json = this.toJSON();
        let result = new GuidEntityDto();
        result.init(json);
        return result;
    }
}

export class Int64IdNameDto implements IInt64IdNameDto {
    id: number;
    name: string | undefined;

    constructor(data?: IInt64IdNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): Int64IdNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64IdNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): Int64IdNameDto {
        const json = this.toJSON();
        let result = new Int64IdNameDto();
        result.init(json);
        return result;
    }
}

export enum OnDemandEmailType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class PartnerEditDto implements IPartnerEditDto {
    tenantId: number | undefined;
    name: string;
    website: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    city: string;
    state: string;
    zipcode: string;
    taxId: string | undefined;
    commissionRate: number;
    isApproved: boolean;
    isDirectDeposit: boolean;
    approveTime: moment.Moment | undefined;
    contractTypeId: number;
    advisorEntitlementId: number | undefined;
    advisorEntitlement: AdvisorEntitlementDto;
    partnerStatus: PartnerStatus;
    partnerSupports: PartnerSupportEditDto[] | undefined;
    partnerAcquisitionId: number;
    partnerAcquisition: PartnerAcquisitionListDto;
    readonly fullAddress: string | undefined;
    apid: number | undefined;
    uuid: string;
    externalId: string | undefined;
    isMatrixEnabled: boolean;
    readonly canSeeCommissionMatrix: boolean;
    id: number;

    constructor(data?: IPartnerEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.website = _data['website'];
            this.address = _data['address'];
            this.address2 = _data['address2'];
            this.city = _data['city'];
            this.state = _data['state'];
            this.zipcode = _data['zipcode'];
            this.taxId = _data['taxId'];
            this.commissionRate = _data['commissionRate'];
            this.isApproved = _data['isApproved'];
            this.isDirectDeposit = _data['isDirectDeposit'];
            this.approveTime = _data['approveTime'] ? moment(_data['approveTime'].toString()) : <any>undefined;
            this.contractTypeId = _data['contractTypeId'];
            this.advisorEntitlementId = _data['advisorEntitlementId'];
            this.advisorEntitlement = _data['advisorEntitlement']
                ? AdvisorEntitlementDto.fromJS(_data['advisorEntitlement'])
                : <any>undefined;
            this.partnerStatus = _data['partnerStatus'];
            if (Array.isArray(_data['partnerSupports'])) {
                this.partnerSupports = [] as any;
                for (let item of _data['partnerSupports']) this.partnerSupports.push(PartnerSupportEditDto.fromJS(item));
            }
            this.partnerAcquisitionId = _data['partnerAcquisitionId'];
            this.partnerAcquisition = _data['partnerAcquisition']
                ? PartnerAcquisitionListDto.fromJS(_data['partnerAcquisition'])
                : <any>undefined;
            (<any>this).fullAddress = _data['fullAddress'];
            this.apid = _data['apid'];
            this.uuid = _data['uuid'];
            this.externalId = _data['externalId'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            (<any>this).canSeeCommissionMatrix = _data['canSeeCommissionMatrix'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['website'] = this.website;
        data['address'] = this.address;
        data['address2'] = this.address2;
        data['city'] = this.city;
        data['state'] = this.state;
        data['zipcode'] = this.zipcode;
        data['taxId'] = this.taxId;
        data['commissionRate'] = this.commissionRate;
        data['isApproved'] = this.isApproved;
        data['isDirectDeposit'] = this.isDirectDeposit;
        data['approveTime'] = this.approveTime ? this.approveTime.toISOString() : <any>undefined;
        data['contractTypeId'] = this.contractTypeId;
        data['advisorEntitlementId'] = this.advisorEntitlementId;
        data['advisorEntitlement'] = this.advisorEntitlement ? this.advisorEntitlement.toJSON() : <any>undefined;
        data['partnerStatus'] = this.partnerStatus;
        if (Array.isArray(this.partnerSupports)) {
            data['partnerSupports'] = [];
            for (let item of this.partnerSupports) data['partnerSupports'].push(item.toJSON());
        }
        data['partnerAcquisitionId'] = this.partnerAcquisitionId;
        data['partnerAcquisition'] = this.partnerAcquisition ? this.partnerAcquisition.toJSON() : <any>undefined;
        data['fullAddress'] = this.fullAddress;
        data['apid'] = this.apid;
        data['uuid'] = this.uuid;
        data['externalId'] = this.externalId;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['canSeeCommissionMatrix'] = this.canSeeCommissionMatrix;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerEditDto {
        const json = this.toJSON();
        let result = new PartnerEditDto();
        result.init(json);
        return result;
    }
}

export class PartnerSupportEditDto implements IPartnerSupportEditDto {
    partnerId: number;
    userId: number | undefined;
    user: UserListDto;
    type: PartnerSupportType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IPartnerSupportEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.userId = _data['userId'];
            this.user = _data['user'] ? UserListDto.fromJS(_data['user']) : <any>undefined;
            this.type = _data['type'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnerSupportEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSupportEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['type'] = this.type;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnerSupportEditDto {
        const json = this.toJSON();
        let result = new PartnerSupportEditDto();
        result.init(json);
        return result;
    }
}

export class PartnersDto implements IPartnersDto {
    name: string;
    nameExtended: string | undefined;
    isMatrixEnabled: boolean;
    id: number;

    constructor(data?: IPartnersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.nameExtended = _data['nameExtended'];
            this.isMatrixEnabled = _data['isMatrixEnabled'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PartnersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['nameExtended'] = this.nameExtended;
        data['isMatrixEnabled'] = this.isMatrixEnabled;
        data['id'] = this.id;
        return data;
    }

    clone(): PartnersDto {
        const json = this.toJSON();
        let result = new PartnersDto();
        result.init(json);
        return result;
    }
}

export class ProductCategoryListDto implements IProductCategoryListDto {
    id: number | undefined;
    name: string;

    constructor(data?: IProductCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ProductCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): ProductCategoryListDto {
        const json = this.toJSON();
        let result = new ProductCategoryListDto();
        result.init(json);
        return result;
    }
}

export class ProductListDto implements IProductListDto {
    id: number | undefined;
    productCategory: ProductCategoryListDto;
    name: string;

    constructor(data?: IProductListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.productCategory = _data['productCategory'] ? ProductCategoryListDto.fromJS(_data['productCategory']) : <any>undefined;
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): ProductListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['productCategory'] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data['name'] = this.name;
        return data;
    }

    clone(): ProductListDto {
        const json = this.toJSON();
        let result = new ProductListDto();
        result.init(json);
        return result;
    }
}

export class SalesCampaignDto implements ISalesCampaignDto {
    id: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    name: string | undefined;
    partnerId: number;
    partnerName: string | undefined;
    campaignType: CampaignType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;

    constructor(data?: ISalesCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.name = _data['name'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.campaignType = _data['campaignType'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
        }
    }

    static fromJS(data: any): SalesCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['name'] = this.name;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['campaignType'] = this.campaignType;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        return data;
    }

    clone(): SalesCampaignDto {
        const json = this.toJSON();
        let result = new SalesCampaignDto();
        result.init(json);
        return result;
    }
}

export class StringEntityDto implements IStringEntityDto {
    id: string | undefined;

    constructor(data?: IStringEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): StringEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new StringEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }

    clone(): StringEntityDto {
        const json = this.toJSON();
        let result = new StringEntityDto();
        result.init(json);
        return result;
    }
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    title: string | undefined;
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    quoteManagement: QuoteManagementSettingsEditDto;
    orderManagement: OrderManagementSettingsEditDto;
    emailTemplateManagement: EmailTemplateSettingsEditDto;
    emailTemplateFromAddressManagement: EmailTemplateFromAddressSettingsEditDto;
    emailUnsubscribeGroup: EmailUnsubscribeSettingsEditDto;
    azureStorage: AzureStorageSettingsEditDto;
    commissionEstimateDisclaimer: CommissionEstimateDisclaimerEditDto;
    tokenManagement: TokenManagementSettingsEditDto;
    integrationManagement: IntegrationSettingsEditDto;
    emailDefaults: EmailDefaultsDto;
    googleMapsApiKey: string | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data['title'];
            this.general = _data['general'] ? GeneralSettingsEditDto.fromJS(_data['general']) : <any>undefined;
            this.userManagement = _data['userManagement']
                ? TenantUserManagementSettingsEditDto.fromJS(_data['userManagement'])
                : new TenantUserManagementSettingsEditDto();
            this.email = _data['email'] ? EmailSettingsEditDto.fromJS(_data['email']) : <any>undefined;
            this.ldap = _data['ldap'] ? LdapSettingsEditDto.fromJS(_data['ldap']) : <any>undefined;
            this.security = _data['security'] ? SecuritySettingsEditDto.fromJS(_data['security']) : new SecuritySettingsEditDto();
            this.quoteManagement = _data['quoteManagement']
                ? QuoteManagementSettingsEditDto.fromJS(_data['quoteManagement'])
                : <any>undefined;
            this.orderManagement = _data['orderManagement']
                ? OrderManagementSettingsEditDto.fromJS(_data['orderManagement'])
                : <any>undefined;
            this.emailTemplateManagement = _data['emailTemplateManagement']
                ? EmailTemplateSettingsEditDto.fromJS(_data['emailTemplateManagement'])
                : <any>undefined;
            this.emailTemplateFromAddressManagement = _data['emailTemplateFromAddressManagement']
                ? EmailTemplateFromAddressSettingsEditDto.fromJS(_data['emailTemplateFromAddressManagement'])
                : <any>undefined;
            this.emailUnsubscribeGroup = _data['emailUnsubscribeGroup']
                ? EmailUnsubscribeSettingsEditDto.fromJS(_data['emailUnsubscribeGroup'])
                : <any>undefined;
            this.azureStorage = _data['azureStorage'] ? AzureStorageSettingsEditDto.fromJS(_data['azureStorage']) : <any>undefined;
            this.commissionEstimateDisclaimer = _data['commissionEstimateDisclaimer']
                ? CommissionEstimateDisclaimerEditDto.fromJS(_data['commissionEstimateDisclaimer'])
                : <any>undefined;
            this.tokenManagement = _data['tokenManagement']
                ? TokenManagementSettingsEditDto.fromJS(_data['tokenManagement'])
                : <any>undefined;
            this.integrationManagement = _data['integrationManagement']
                ? IntegrationSettingsEditDto.fromJS(_data['integrationManagement'])
                : <any>undefined;
            this.emailDefaults = _data['emailDefaults'] ? EmailDefaultsDto.fromJS(_data['emailDefaults']) : <any>undefined;
            this.googleMapsApiKey = _data['googleMapsApiKey'];
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['title'] = this.title;
        data['general'] = this.general ? this.general.toJSON() : <any>undefined;
        data['userManagement'] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data['email'] = this.email ? this.email.toJSON() : <any>undefined;
        data['ldap'] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data['security'] = this.security ? this.security.toJSON() : <any>undefined;
        data['quoteManagement'] = this.quoteManagement ? this.quoteManagement.toJSON() : <any>undefined;
        data['orderManagement'] = this.orderManagement ? this.orderManagement.toJSON() : <any>undefined;
        data['emailTemplateManagement'] = this.emailTemplateManagement ? this.emailTemplateManagement.toJSON() : <any>undefined;
        data['emailTemplateFromAddressManagement'] = this.emailTemplateFromAddressManagement
            ? this.emailTemplateFromAddressManagement.toJSON()
            : <any>undefined;
        data['emailUnsubscribeGroup'] = this.emailUnsubscribeGroup ? this.emailUnsubscribeGroup.toJSON() : <any>undefined;
        data['azureStorage'] = this.azureStorage ? this.azureStorage.toJSON() : <any>undefined;
        data['commissionEstimateDisclaimer'] = this.commissionEstimateDisclaimer
            ? this.commissionEstimateDisclaimer.toJSON()
            : <any>undefined;
        data['tokenManagement'] = this.tokenManagement ? this.tokenManagement.toJSON() : <any>undefined;
        data['integrationManagement'] = this.integrationManagement ? this.integrationManagement.toJSON() : <any>undefined;
        data['emailDefaults'] = this.emailDefaults ? this.emailDefaults.toJSON() : <any>undefined;
        data['googleMapsApiKey'] = this.googleMapsApiKey;
        return data;
    }

    clone(): TenantSettingsEditDto {
        const json = this.toJSON();
        let result = new TenantSettingsEditDto();
        result.init(json);
        return result;
    }
}

export class UploadFileInput implements IUploadFileInput {
    fileName: string;
    customerId: number;

    constructor(data?: IUploadFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.customerId = _data['customerId'];
        }
    }

    static fromJS(data: any): UploadFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['customerId'] = this.customerId;
        return data;
    }

    clone(): UploadFileInput {
        const json = this.toJSON();
        let result = new UploadFileInput();
        result.init(json);
        return result;
    }
}

export class UserListDto implements IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    title: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    company: string | undefined;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    officeCity: string | undefined;
    id: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.title = _data['title'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.profilePictureId = _data['profilePictureId'];
            this.isEmailConfirmed = _data['isEmailConfirmed'];
            this.company = _data['company'];
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
            this.isActive = _data['isActive'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.officeCity = _data['officeCity'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['title'] = this.title;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['profilePictureId'] = this.profilePictureId;
        data['isEmailConfirmed'] = this.isEmailConfirmed;
        data['company'] = this.company;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data['isActive'] = this.isActive;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['officeCity'] = this.officeCity;
        data['id'] = this.id;
        return data;
    }

    clone(): UserListDto {
        const json = this.toJSON();
        let result = new UserListDto();
        result.init(json);
        return result;
    }
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
    description: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        data['description'] = this.description;
        return data;
    }

    clone(): UserListRoleDto {
        const json = this.toJSON();
        let result = new UserListRoleDto();
        result.init(json);
        return result;
    }
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    companyUuid: string | undefined;
    profilePictureId: string | undefined;
    partnerId: number | undefined;
    providerId: number | undefined;
    details: RollDetails[] | undefined;
    partnerName: string | undefined;
    isImpersonator: boolean;
    userExperience: string | undefined;
    isInvestOwner: boolean;
    uuid: string | undefined;
    marketplaceRoles: string[] | undefined;
    token: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.companyUuid = _data['companyUuid'];
            this.profilePictureId = _data['profilePictureId'];
            this.partnerId = _data['partnerId'];
            this.providerId = _data['providerId'];
            if (Array.isArray(_data['details'])) {
                this.details = [] as any;
                for (let item of _data['details']) this.details.push(RollDetails.fromJS(item));
            }
            this.partnerName = _data['partnerName'];
            this.isImpersonator = _data['isImpersonator'];
            this.userExperience = _data['userExperience'];
            this.isInvestOwner = _data['isInvestOwner'];
            this.uuid = _data['uuid'];
            if (Array.isArray(_data['marketplaceRoles'])) {
                this.marketplaceRoles = [] as any;
                for (let item of _data['marketplaceRoles']) this.marketplaceRoles.push(item);
            }
            this.token = _data['token'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['companyUuid'] = this.companyUuid;
        data['profilePictureId'] = this.profilePictureId;
        data['partnerId'] = this.partnerId;
        data['providerId'] = this.providerId;
        if (Array.isArray(this.details)) {
            data['details'] = [];
            for (let item of this.details) data['details'].push(item.toJSON());
        }
        data['partnerName'] = this.partnerName;
        data['isImpersonator'] = this.isImpersonator;
        data['userExperience'] = this.userExperience;
        data['isInvestOwner'] = this.isInvestOwner;
        data['uuid'] = this.uuid;
        if (Array.isArray(this.marketplaceRoles)) {
            data['marketplaceRoles'] = [];
            for (let item of this.marketplaceRoles) data['marketplaceRoles'].push(item);
        }
        data['token'] = this.token;
        data['id'] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}
